<template>
  <section class="badge-order-admin">
    <header class="bo-masthead">
      <div class="bo-masthead__brand">
        <span class="bo-masthead__mark" aria-hidden="true">
          <i class="el-icon-medal" />
        </span>
        <div class="bo-masthead__text">
          <h1 class="bo-masthead__title">校徽订购管理</h1>
          <p class="bo-masthead__desc">配置办理规则、收集字段、款式套餐与订单处理</p>
        </div>
      </div>
      <div class="bo-masthead__status">
        <span class="bo-status-pill" :class="config.Enabled ? 'is-on' : 'is-off'">
          <i :class="config.Enabled ? 'el-icon-circle-check' : 'el-icon-remove-outline'" />
          {{ config.Enabled ? '服务已启用' : '服务未启用' }}
        </span>
      </div>
    </header>

    <div class="bo-overview">
      <button
        v-for="item in overviewCards"
        :key="item.key"
        type="button"
        class="bo-overview-card"
        :class="{ 'is-active': activeTab === item.tab }"
        @click="switchTab(item.tab)">
        <span class="bo-overview-card__icon" :class="'tone-' + item.tone">
          <i :class="item.icon" />
        </span>
        <span class="bo-overview-card__body">
          <span class="bo-overview-card__value">{{ item.value }}</span>
          <span class="bo-overview-card__label">{{ item.label }}</span>
        </span>
      </button>
    </div>

    <div class="bo-workspace">
      <nav class="bo-sidebar" aria-label="校徽订购功能导航">
        <button
          v-for="nav in navItems"
          :key="nav.key"
          type="button"
          class="bo-nav-item"
          :class="{ 'is-active': activeTab === nav.key }"
          @click="switchTab(nav.key)">
          <span class="bo-nav-item__icon"><i :class="nav.icon" /></span>
          <span class="bo-nav-item__text">
            <span class="bo-nav-item__label">{{ nav.label }}</span>
            <span class="bo-nav-item__hint">{{ nav.hint }}</span>
          </span>
          <span v-if="nav.badge != null" class="bo-nav-item__badge">{{ nav.badge }}</span>
        </button>
      </nav>

      <main class="bo-main">
      <div v-show="activeTab === 'config'" class="bo-pane">
        <el-form
          ref="configForm"
          :model="config"
          :rules="configFormRules"
          label-width="130px"
          size="small"
          class="config-form">

          <el-collapse v-model="configCollapseActive" class="bo-collapse">
          <!-- 分组一：核心功能开关与起订设置 -->
          <el-collapse-item name="core">
            <template slot="title">
              <span class="bo-collapse__title"><i class="el-icon-setting" />核心设置与起订量</span>
            </template>
            <el-row :gutter="24">
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="功能开关">
                  <el-switch v-model="config.Enabled" active-color="#14b8a6" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="首张校徽">
                  <el-radio-group v-model="config.FirstBadgeFree">
                    <el-radio :label="true">免费办理</el-radio>
                    <el-radio :label="false">不免费</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="默认起订数量">
                  <el-select v-model="config.DefaultMinQty" style="width: 120px;">
                    <el-option v-for="n in qtyOptions" :key="'d'+n" :label="n + ' 个'" :value="n" />
                  </el-select>
                  <span class="hint">复购时最少购买</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="首次最低购买">
                  <el-select v-model="config.FirstTimeMinQty" style="width: 120px;">
                    <el-option v-for="n in qtyOptions" :key="'f'+n" :label="n + ' 个'" :value="n" />
                  </el-select>
                  <span class="hint warn">建议首次设为 1</span>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="监护人最少人数">
                  <el-select v-model="config.MinGuardianCount" style="width: 120px;">
                    <el-option
                      v-for="n in guardianMinOptions"
                      :key="'gmin'+n"
                      :label="n === 0 ? '可不填' : (n + ' 人')"
                      :value="n" />
                  </el-select>
                  <span class="hint">启用「监护人信息」字段时生效</span>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="监护人最多人数">
                  <el-select v-model="config.MaxGuardianCount" style="width: 120px;">
                    <el-option v-for="n in guardianMaxOptions" :key="'gmax'+n" :label="n + ' 人'" :value="n" />
                  </el-select>
                  <span class="hint">建议 1～5</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!-- 分组二：办理规则与支付配置 -->
          <el-collapse-item name="payment">
            <template slot="title">
              <span class="bo-collapse__title"><i class="el-icon-wallet" />办理方式与收费</span>
            </template>
            <el-row :gutter="24">
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="办理方式" class="config-form-item--apply-mode">
                  <el-radio-group v-model="config.ApplyMode">
                    <el-radio :label="1">收集信息+付费</el-radio>
                    <el-radio :label="0">仅收集信息</el-radio>
                  </el-radio-group>
                  <p v-if="config.ApplyMode === 1" class="form-tip form-tip--below-control info">
                    <i class="el-icon-info"></i> 家长提交后需在线支付，必须配置支付宝支付通道
                  </p>
                  <p v-else class="form-tip form-tip--below-control">
                    <i class="el-icon-info"></i> 仅登记信息，无需支付与支付宝配置
                  </p>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="办理时间">
                  每月
                  <el-select v-model="config.ApplyDayStart" style="width: 90px;">
                    <el-option v-for="d in dayOptions" :key="'s'+d" :label="d + ' 日'" :value="d" />
                  </el-select>
                  至
                  <el-select v-model="config.ApplyDayEnd" style="width: 90px;">
                    <el-option v-for="d in dayOptions" :key="'e'+d" :label="d + ' 日'" :value="d" />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" class="config-col-alipay" v-show="config.ApplyMode === 1">
                <el-form-item
                  prop="PlatformAliPayConfigId"
                  class="config-form-item--alipay">
                  <span slot="label">
                    <span class="config-required-star">*</span>支付宝配置
                  </span>
                  <el-select
                    v-model="config.PlatformAliPayConfigId"
                    placeholder="请选择支付宝应用"
                    filterable
                    clearable
                    style="width: 100%;">
                    <el-option
                      v-for="c in aliPayConfigOptions"
                      :key="c.Id"
                      :label="aliPayConfigOptionLabel(c)"
                      :value="c.Id"
                      :disabled="!c.Enabled">
                      <span>{{ c.Name }}</span>
                      <span class="ali-pay-option-appid">{{ c.AppId }}</span>
                      <el-tag v-if="!c.Enabled" type="info" size="mini" style="margin-left: 6px;">已停用</el-tag>
                    </el-option>
                  </el-select>
                  <p class="form-tip form-tip--below-control"><i class="el-icon-warning-outline"></i> 收费办理时此项必选，且须为已启用的配置</p>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!-- 分组三：界面展示与宣传海报 -->
          <el-collapse-item name="display">
            <template slot="title">
              <span class="bo-collapse__title"><i class="el-icon-picture-outline" />界面展示与分享</span>
            </template>
            <el-row :gutter="24">
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="标题名称">
                  <el-input v-model="config.TitleName" maxlength="20" show-word-limit placeholder="小程序显示标题" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="分享标题">
                  <el-input v-model="config.ShareTitle" maxlength="20" show-word-limit placeholder="转发给家长的分享描述" />
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="产品图片">
                  <div class="config-image-upload">
                    <el-upload
                      v-if="!deferredImageDisplay('productImage', config.ProductImageUrl)"
                      class="config-image-uploader"
                      list-type="picture-card"
                      action="#"
                      :auto-upload="false"
                      :limit="1"
                      :show-file-list="false"
                      :on-change="(file) => handleConfigImageChange('ProductImageUrl', 'productImage', 'BadgeOrderProduct', file)">
                      <i class="el-icon-plus" />
                    </el-upload>
                    <div v-else class="config-image-preview">
                      <div class="image-wrapper">
                        <img v-if="deferredImageDisplay('productImage', config.ProductImageUrl)" v-oss-src="deferredImageDisplay('productImage', config.ProductImageUrl)" class="config-image-thumb config-image-thumb--banner" alt="" />
                        <div class="image-hover-mask">
                          <span @click="previewConfigImage(config.ProductImageUrl)"><i class="el-icon-view"></i>预览</span>
                          <span class="danger" @click="removeConfigImage('ProductImageUrl', 'productImage')"><i class="el-icon-delete"></i>删除</span>
                        </div>
                      </div>
                    </div>
                    <p class="upload-tip">办理页头图，建议 750×240 像素</p>
                  </div>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="分享封面">
                  <div class="config-image-upload">
                    <el-upload
                      v-if="!deferredImageDisplay('shareCover', config.ShareCoverUrl)"
                      class="config-image-uploader"
                      list-type="picture-card"
                      action="#"
                      :auto-upload="false"
                      :limit="1"
                      :show-file-list="false"
                      :on-change="(file) => handleConfigImageChange('ShareCoverUrl', 'shareCover', 'BadgeOrderShareCover', file)">
                      <i class="el-icon-plus" />
                    </el-upload>
                    <div v-else class="config-image-preview">
                      <div class="image-wrapper">
                        <img v-if="deferredImageDisplay('shareCover', config.ShareCoverUrl)" v-oss-src="deferredImageDisplay('shareCover', config.ShareCoverUrl)" class="config-image-thumb" alt="" />
                        <div class="image-hover-mask">
                          <span @click="previewConfigImage(config.ShareCoverUrl)"><i class="el-icon-view"></i>预览</span>
                          <span class="danger" @click="removeConfigImage('ShareCoverUrl', 'shareCover')"><i class="el-icon-delete"></i>删除</span>
                        </div>
                      </div>
                    </div>
                    <p class="upload-tip">小程序分享封面，建议 380×304 像素</p>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12">
                <el-form-item label="活动海报">
                  <div class="config-image-upload">
                    <el-upload
                      v-if="!deferredImageDisplay('poster', config.PosterUrl)"
                      class="config-image-uploader"
                      list-type="picture-card"
                      action="#"
                      :auto-upload="false"
                      :limit="1"
                      :show-file-list="false"
                      :on-change="(file) => handleConfigImageChange('PosterUrl', 'poster', 'BadgeOrderPoster', file)">
                      <i class="el-icon-plus" />
                    </el-upload>
                    <div v-else class="config-image-preview">
                      <div class="image-wrapper">
                        <img v-if="deferredImageDisplay('poster', config.PosterUrl)" v-oss-src="deferredImageDisplay('poster', config.PosterUrl)" class="config-image-thumb config-image-thumb--wide" alt="" />
                        <div class="image-hover-mask">
                          <span @click="previewConfigImage(config.PosterUrl)"><i class="el-icon-view"></i>预览</span>
                          <span class="danger" @click="removeConfigImage('PosterUrl', 'poster')"><i class="el-icon-delete"></i>删除</span>
                        </div>
                      </div>
                    </div>
                    <p class="upload-tip">首页活动海报，建议比例 2:1</p>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!-- 分组四：产品详情富文本 -->
          <el-collapse-item name="detail">
            <template slot="title">
              <span class="bo-collapse__title"><i class="el-icon-document" />订购详情图文</span>
            </template>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="产品详情" class="config-form-item--full">
                  <div class="product-detail-toolbar">
                    <span class="product-detail-toolbar-label">说明文案预设</span>
                    <el-select
                      v-model="productDetailTemplateKey"
                      placeholder="快速载入说明文案"
                      style="width: 240px;"
                      clearable
                      @change="onProductDetailTemplateChange">
                      <el-option
                        v-for="t in productDetailTemplateOptions"
                        :key="t.key || 'custom'"
                        :label="t.label"
                        :value="t.key" />
                    </el-select>
                    <span class="hint"><i class="el-icon-info"></i> 与「样式模板」无关；下方为已保存文案，切换预设将覆盖当前内容</span>
                  </div>
                  <quill-editor
                    v-model="config.ProductDetailHtml"
                    ref="productDetailQuill"
                    class="product-detail-editor"
                    :options="editorOption" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
          </el-collapse>

          <!-- 底部保存按钮 -->
          <div class="config-form-actions">
            <el-button type="primary" :loading="configSaving" class="save-btn" @click="saveConfig">
              <i class="el-icon-check"></i> 保存全部配置
            </el-button>
          </div>
        </el-form>
      </div>

      <div v-show="activeTab === 'fields'" class="bo-pane">
        <div class="bo-panel">
          <div class="bo-panel__head">
            <div class="bo-panel__title">
              收集字段
              <span class="bo-panel__count">已启用 {{ enabledFieldsCount }} / {{ collectFieldPresets.length }}</span>
            </div>
          </div>
          <div class="bo-panel__body">
            <div class="field-card-grid">
              <article
                v-for="item in fieldMatrixRows"
                :key="item.preset.key"
                class="field-card"
                :class="{
                  'is-enabled': item.enabled,
                  'is-disabled': item.added && !item.enabled,
                  'is-empty': !item.added
                }">
                <div class="field-card__top">
                  <span class="field-card__sort">{{ item.added ? item.field.SortNo : '—' }}</span>
                  <span
                    class="field-status-dot"
                    :class="!item.added ? 'is-off' : (item.enabled ? 'is-on' : 'is-disabled')">
                    {{ !item.added ? '未配置' : (item.enabled ? '已启用' : '已禁用') }}
                  </span>
                </div>
                <div class="field-card__icon"><i :class="fieldPresetIcon(item.preset.key)" /></div>
                <h4 class="field-card__title">{{ item.preset.label }}</h4>
                <div class="field-card__tags">
                  <span>{{ fieldTypeLabel(item.preset.fieldType) }}</span>
                  <span v-if="item.added">{{ item.field.Required ? '必填' : '选填' }}</span>
                  <span v-else>待启用</span>
                </div>
                <p class="field-card__desc">
                  {{ item.added ? fieldRemark(item.field) : fieldPresetDefaultRemark(item.preset.key) }}
                </p>
                <div class="field-card__actions">
                  <template v-if="item.added">
                    <el-button type="text" size="mini" @click="openFieldDialog(item.field)">编辑</el-button>
                    <el-button
                      v-if="item.enabled"
                      type="text"
                      size="mini"
                      class="warning"
                      @click="setFieldEnabled(item.field, false)">禁用</el-button>
                    <el-button
                      v-else
                      type="text"
                      size="mini"
                      @click="setFieldEnabled(item.field, true)">启用</el-button>
                  </template>
                  <el-button v-else type="text" size="mini" @click="quickAddField(item.preset.key)">启用</el-button>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>

      <div v-show="activeTab === 'templates'" class="bo-pane">
        <div class="bo-callout">
          <i class="el-icon-info" />
          <span>校徽样式使用固定设计稿，学校标题已在底图中；点击下方表格缩略图或「校徽效果模拟器」可直接进行数据调试与实时预览。</span>
        </div>
        <el-alert v-if="!templates.length" type="info" :closable="false" show-icon title="请先新增样式模板并上传校徽背景图，即可看到预览效果" />

        <div class="bo-panel">
          <div class="bo-panel__head">
            <div class="bo-panel__title">样式模板列表</div>
            <div class="bo-panel__actions">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="openTemplateDialog()">新增模板</el-button>
              <el-button v-if="defaultStyleTemplate" type="success" size="small" icon="el-icon-monitor" plain @click="openStyleTemplatePreview(defaultStyleTemplate)">校徽效果模拟器</el-button>
            </div>
          </div>
          <div class="bo-panel__body bo-panel__body--flush">
        <el-table :data="templates" size="small">
          <el-table-column prop="Name" label="名称" min-width="160" align="center">
            <template slot-scope="s">
              <span>{{ s.row.Name }}</span>
              <el-tag v-if="s.row.IsDefault" size="mini" type="success" effect="plain" class="template-default-tag">默认</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="预览" min-width="120" align="center">
            <template slot-scope="s">
              <img
                v-if="s.row.PreviewImageUrl"
                :src="fullImgUrl(s.row.PreviewImageUrl)"
                class="thumb thumb--clickable"
                title="点击查看校徽效果预览"
                alt=""
                @click="openStyleTemplatePreview(s.row)" />
              <el-button
                v-else
                type="text"
                size="mini"
                @click="openTemplateDialog(s.row)">
                设置
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="CanvasWidth" label="宽" min-width="90" align="center" />
          <el-table-column prop="CanvasHeight" label="高" min-width="90" align="center" />
          <el-table-column label="操作" min-width="200" align="center">
            <template slot-scope="s">
              <div class="table-op-pair">
                <el-button type="text" class="table-op-link" @click="openTemplateDialog(s.row)">编辑</el-button>
                <el-button
                  v-if="!s.row.IsDefault"
                  type="text"
                  class="table-op-link"
                  @click="setDefaultTemplate(s.row)">设为默认</el-button>
                <el-button
                  v-if="!s.row.IsDefault"
                  type="text"
                  class="table-op-link table-op-link--danger"
                  @click="removeTemplate(s.row.Id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
          </div>
        </div>
      </div>

      <div v-show="activeTab === 'packages'" class="bo-pane">
        <div class="bo-panel">
          <div class="bo-panel__head">
            <div class="bo-panel__title">校徽套餐</div>
            <div class="bo-panel__actions">
              <el-button type="primary" size="small" @click="openPackageDialog()">新增套餐</el-button>
            </div>
          </div>
          <div class="bo-panel__body bo-panel__body--flush">
        <el-table :data="packages" size="small">
          <el-table-column prop="SortNo" label="序号" width="72" align="center">
            <template slot-scope="s">
              <span class="package-sort-no">{{ s.row.SortNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Name" label="套餐名称" min-width="160" align="center" />
          <el-table-column label="样式模板" min-width="120" align="center" show-overflow-tooltip>
            <template slot-scope="s">
              <span>{{ s.row.StyleTemplateName || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="样式" min-width="110" align="center">
            <template slot-scope="s">
              <img
                v-if="packageStyleThumbUrl(s.row)"
                :src="fullImgUrl(packageStyleThumbUrl(s.row))"
                class="thumb thumb--clickable"
                title="点击查看校徽效果预览"
                alt=""
                @click="openPackageStylePreview(s.row)" />
            </template>
          </el-table-column>
          <el-table-column prop="ModelName" label="款式" min-width="180" align="center" />
          <el-table-column prop="UnitPrice" label="单价(元)" min-width="100" align="center" />
          <el-table-column label="开启" min-width="80" align="center">
            <template slot-scope="s">
              <el-tag :type="s.row.Enabled ? 'success' : 'info'" size="mini">{{ s.row.Enabled ? '开' : '关' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="120" align="center">
            <template slot-scope="s">
              <el-button type="text" @click="openPackageDialog(s.row)">修改</el-button>
              <el-button type="text" class="danger" @click="removePackage(s.row.Id)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
          </div>
        </div>
      </div>

      <div v-show="activeTab === 'orders'" class="bo-pane">
        <div class="bo-callout bo-callout--warn">
          <i class="el-icon-warning-outline" />
          <span>仅可勾选/清理「待支付且下单超过 30 分钟」的订单，清理后标记为已关闭。「导出 Excel」按筛选导出订单明细；「导出制作单」另含证件照 ZIP（不限当前页），建议筛选已支付后导出。制作单中校徽二维码由学号生成，请厂家按 Excel「学号」列制作。</span>
        </div>
        <div class="bo-panel bo-panel--filter">
          <div class="bo-panel__body">
        <div class="toolbar-filter-bar">
          <el-form :inline="true" class="toolbar-filter-form">
            <div class="toolbar-filter-fields">
            <el-form-item label="关键词">
              <el-input v-model="orderQuery.keyword" placeholder="订单号/姓名/学校/手机" clearable class="toolbar-field-w-lg" />
            </el-form-item>
            <el-form-item label="支付状态">
              <el-select v-model="orderQuery.payStatus" clearable placeholder="全部" class="toolbar-field-w-sm">
                <el-option label="待支付" :value="0" />
                <el-option label="已支付" :value="1" />
                <el-option label="失败" :value="2" />
                <el-option label="已关闭" :value="3" />
              </el-select>
            </el-form-item>
            <el-form-item label="下单日期">
              <el-date-picker
                v-model="orderDateRange"
                type="daterange"
                start-placeholder="开始"
                end-placeholder="结束"
                value-format="yyyy-MM-dd"
                :clearable="true"
                class="toolbar-field-w-daterange" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" @click="loadOrders(1)">查询</el-button>
            </el-form-item>
            </div>
            <div class="toolbar-filter-actions">
              <el-button plain class="bo-toolbar-btn" icon="el-icon-download" :loading="orderListExportLoading" @click="exportOrderList">导出 Excel</el-button>
              <el-button plain class="bo-toolbar-btn" icon="el-icon-download" :loading="orderExportLoading" @click="exportOrders">导出制作单</el-button>
              <el-button
                plain
                class="bo-toolbar-btn bo-toolbar-btn--warn"
                :disabled="!orderSelection.length"
                :loading="orderCleanupLoading"
                @click="batchCleanupSelectedOrders">清理选中</el-button>
              <el-button
                plain
                class="bo-toolbar-btn bo-toolbar-btn--danger"
                :loading="orderCleanupLoading"
                @click="batchCleanupAllExpiredOrders">清理全部超时待支付（30分钟）</el-button>
            </div>
          </el-form>
        </div>
          </div>
        </div>
        <div class="bo-panel">
          <div class="bo-panel__head">
            <div class="bo-panel__title">
              订购记录
              <span class="bo-panel__count">共 {{ orderPage.total }} 条</span>
            </div>
          </div>
          <div class="bo-panel__body bo-panel__body--flush">
        <el-table
          ref="orderTable"
          :data="orders"
          v-loading="orderLoading"
          size="small"
          @selection-change="onOrderSelectionChange">
          <template slot="empty">
            <el-empty :image-size="80" description="暂无订购订单记录" style="padding: 30px 0;" />
          </template>
          <el-table-column
            type="selection"
            width="42"
            align="center"
            :selectable="canSelectPendingOrder" />
          <el-table-column prop="OrderNo" label="订单号" min-width="160" show-overflow-tooltip align="center" />
          <el-table-column prop="StudentName" label="学生" min-width="90" align="center" />
          <el-table-column prop="StudentNo" label="学号" min-width="100" show-overflow-tooltip align="center" />
          <el-table-column prop="GuardianCount" label="监护人数量" min-width="100" align="center" />
          <el-table-column prop="SchoolName" label="学校" min-width="140" show-overflow-tooltip align="center" />
          <el-table-column prop="GradeName" label="年级" min-width="90" show-overflow-tooltip align="center" />
          <el-table-column prop="ClassName" label="班级" min-width="100" show-overflow-tooltip align="center" />
          <el-table-column prop="PackageName" label="套餐" min-width="120" show-overflow-tooltip align="center" />
          <el-table-column prop="Quantity" label="数量" min-width="60" align="center" />
          <el-table-column label="应付（元）" min-width="88" align="center">
            <template slot-scope="s">
              {{ s.row.PayableAmount }}
            </template>
          </el-table-column>
          <el-table-column label="实付（元）" min-width="88" align="center">
            <template slot-scope="s">
              {{ orderPaidAmountText(s.row) }}
            </template>
          </el-table-column>
          <el-table-column label="支付" min-width="100" align="center">
            <template slot-scope="s">
              <el-tag :type="payStatusTagType(s.row.PayStatus)" size="small" effect="plain">
                {{ payStatusText(s.row.PayStatus) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="CreateTime" label="下单时间" min-width="150" align="center" />
          <el-table-column fixed="right" label="操作" min-width="200" align="center">
            <template slot-scope="s">
              <div class="table-op-pair">
                <el-button type="text" class="table-op-link" @click="viewOrder(s.row.Id)">详情</el-button>
                <el-button
                  v-if="canRefundOrder(s.row)"
                  type="text"
                  class="table-op-link table-op-link--danger"
                  @click="openRefundDialog(s.row)">退款</el-button>
                <el-button
                  v-if="canSelectPendingOrder(s.row)"
                  type="text"
                  class="table-op-link"
                  :loading="orderCleanupLoading"
                  @click="cleanupSingleOrder(s.row)">清理</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="total, prev, pager, next"
          :current-page="orderPage.page"
          :page-size="orderPage.pageSize"
          :total="orderPage.total"
          @current-change="loadOrders" />
          </div>
        </div>
      </div>

      <div v-show="activeTab === 'statistics'" class="bo-pane">
        <badge-order-statistics v-if="activeTab === 'statistics'" embedded />
      </div>
      </main>
    </div>

    <el-dialog
      :title="fieldForm.Id ? '编辑字段' : '新增字段'"
      :visible.sync="fieldDialogVisible"
      width="480px"
      custom-class="bo-field-dialog">
      <el-form label-width="110px" size="small">
        <el-form-item label="字段类型" required>
          <el-select
            v-model="fieldForm.presetKey"
            placeholder="请选择"
            style="width: 100%;"
            :disabled="!!fieldForm.Id"
            @change="onFieldPresetChange">
            <el-option
              v-for="p in collectFieldPresets"
              :key="p.key"
              :label="p.label"
              :value="p.key"
              :disabled="isFieldPresetUsed(p.key)" />
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="fieldForm.SortNo" :min="1" />
        </el-form-item>
        <el-form-item label="是否必填">
          <el-switch v-model="fieldForm.Required" />
        </el-form-item>
        <el-form-item v-if="fieldForm.presetKey === 'badgeNo'" label="编号设置">
          <el-checkbox v-model="fieldForm.allowParentFill">允许家长直接填写校徽编号</el-checkbox>
          <p class="form-tip">不勾选时：家长只填学号，系统直接将学号作为校徽编号印在校徽上；勾选时：家长直接填写校徽编号</p>
        </el-form-item>
        <el-form-item v-if="fieldForm.presetKey === 'photo'" label="照片要求">
          <el-input v-model="fieldForm.photoSpec" type="textarea" :rows="2" placeholder="展示给家长的说明文字" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="fieldDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveField">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="templateForm.Id ? '编辑模板' : '新增模板'" :visible.sync="templateDialogVisible" width="980px">
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form label-width="100px" size="small">
            <el-form-item label="名称"><el-input v-model="templateForm.Name" /></el-form-item>
            <el-form-item label="设为默认">
              <el-switch v-model="templateForm.IsDefault" />
              <p class="form-tip form-tip--below-control">默认模板不可删除；开启后将取消其它模板的默认状态</p>
            </el-form-item>
            <el-form-item label="校徽背景图">
              <div class="template-bg-fixed-preview">
                <img :src="fullImgUrl(defaultBadgeBackgroundUrl)" alt="" />
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <p class="preview-block-title">实时预览</p>
          <el-form :inline="true" size="mini" class="template-preview-mock-form">
            <el-form-item label="班级">
              <el-input v-model="templatePreviewMock.className" style="width: 100px;" />
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="templatePreviewMock.studentName" style="width: 80px;" />
            </el-form-item>
            <el-form-item label="编号">
              <el-input v-model="templatePreviewMock.badgeNo" style="width: 100px;" />
            </el-form-item>
            <el-form-item label="头像">
              <el-upload
                class="preview-photo-upload"
                name="Files"
                :data="$ossUploadData('BadgeOrderPreview')"
                :action="uploadUrl"
                :show-file-list="false"
                accept=".png,.jpg,.jpeg"
                :on-success="res => onTemplatePreviewPhotoSuccess(res)">
                <el-button size="mini">上传</el-button>
              </el-upload>
              <el-button size="mini" type="text" @click="useSamplePreviewPhoto('template')">示例照</el-button>
            </el-form-item>
          </el-form>
          <badge-style-preview
            :canvas-width="templateForm.CanvasWidth"
            :canvas-height="templateForm.CanvasHeight"
            :background-url="templateForm.PreviewImageUrl"
            :layers-json="templateForm.LayersJson"
            :resolved="templatePreviewMock"
            :max-width="460" />
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="templateDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveTemplate">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="packageForm.Id ? '编辑套餐' : '新增套餐'" :visible.sync="packageDialogVisible" width="620px">
      <el-form label-width="110px" size="small">
        <el-form-item label="套餐名称"><el-input v-model="packageForm.Name" /></el-form-item>
        <el-form-item label="显示序号">
          <el-input-number v-model="packageForm.SortNo" :min="1" :step="1" style="width: 140px;" />
          <p class="form-tip form-tip--below-control">序号越小越靠前，家长端按此顺序展示套餐</p>
        </el-form-item>
        <el-form-item label="样式模板">
          <el-select v-model="packageForm.StyleTemplateId" style="width: 100%;">
            <el-option v-for="t in templates" :key="t.Id" :label="t.Name" :value="t.Id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="packagePreviewTemplate" label="套餐预览">
          <badge-style-preview
            :canvas-width="packagePreviewTemplate.CanvasWidth"
            :canvas-height="packagePreviewTemplate.CanvasHeight"
            :background-url="packagePreviewTemplate.PreviewImageUrl"
            :layers-json="packagePreviewTemplate.LayersJson"
            :resolved="templatePreviewMock"
            :max-width="400" />
        </el-form-item>
        <el-form-item label="款式"><el-input v-model="packageForm.ModelName" /></el-form-item>
        <el-form-item label="销售单价"><el-input-number v-model="packageForm.UnitPrice" :min="0" :precision="2" style="width: 160px;" /></el-form-item>
        <el-form-item label="启用"><el-switch v-model="packageForm.Enabled" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="packageDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="savePackage">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="orderDetailDialogTitle"
      :visible.sync="orderDetailVisible"
      width="720px"
      top="8vh"
      append-to-body
      custom-class="bo-order-detail-dialog"
      @closed="onOrderDetailClosed">
      <div v-if="orderDetail" class="order-detail" v-loading="orderDetailLoading">
        <el-tabs v-model="orderDetailTab" class="order-detail-tabs">
          <el-tab-pane label="基本信息" name="basic">
            <div class="order-detail-grid order-detail-grid--2">
              <div class="order-detail-card">
                <h4 class="order-detail-card__title">订单信息</h4>
                <dl class="order-detail-dl">
                  <div><dt>订单号</dt><dd>{{ orderDetail.OrderNo }}</dd></div>
                  <div>
                    <dt>支付状态</dt>
                    <dd>{{ payStatusText(orderDetail.PayStatus) }} / {{ orderStatusText(orderDetail.OrderStatus) }}</dd>
                  </div>
                  <div><dt>应付金额</dt><dd>{{ orderDetail.PayableAmount }} 元</dd></div>
                  <div><dt>实付金额</dt><dd>{{ orderDetail.PaidAmount || 0 }} 元</dd></div>
                  <div v-if="orderDetail.PayStatus === 1 && orderRefundRemain(orderDetail) > 0">
                    <dt>退款</dt>
                    <dd>已退 {{ orderDetail.RefundAmount || 0 }} 元，可退 {{ orderRefundRemain(orderDetail) }} 元</dd>
                  </div>
                  <div v-else-if="orderDetail.PayStatus === 1 && (orderDetail.RefundAmount || 0) > 0">
                    <dt>退款</dt>
                    <dd>已退 {{ orderDetail.RefundAmount || 0 }} 元</dd>
                  </div>
                  <div v-if="orderDetail.TradeNo"><dt>支付宝交易号</dt><dd>{{ orderDetail.TradeNo }}</dd></div>
                  <div><dt>首张免费</dt><dd>{{ orderDetail.IsFirstBadgeFreeApplied ? '是' : '否' }}</dd></div>
                  <div><dt>套餐</dt><dd>{{ orderDetail.PackageName }} × {{ orderDetail.Quantity }}</dd></div>
                  <div v-if="orderDetail.CreateTime"><dt>下单时间</dt><dd>{{ orderDetail.CreateTime }}</dd></div>
                  <div v-if="orderDetail.PayTime"><dt>支付时间</dt><dd>{{ orderDetail.PayTime }}</dd></div>
                </dl>
              </div>
              <div class="order-detail-card">
                <h4 class="order-detail-card__title">学生信息</h4>
                <dl class="order-detail-dl">
                  <div><dt>学生</dt><dd>{{ orderDetail.StudentName || '—' }}</dd></div>
                  <div><dt>学号</dt><dd>{{ orderDetail.StudentNo || '—' }}</dd></div>
                  <div><dt>学校</dt><dd>{{ orderDetail.SchoolName || '—' }}</dd></div>
                  <div><dt>年级</dt><dd>{{ orderDetail.GradeName || '—' }}</dd></div>
                  <div><dt>班级</dt><dd>{{ orderDetail.ClassName || '—' }}</dd></div>
                  <div><dt>校徽编号</dt><dd>{{ orderDetail.BadgeNo || '—' }}</dd></div>
                  <div><dt>联系方式</dt><dd>{{ orderDetail.ParentPhone || '—' }}</dd></div>
                  <div>
                    <dt>监护人</dt>
                    <dd>
                      <el-button type="text" @click="orderDetailTab = 'guardians'">
                        {{ orderDetail.GuardianCount || 0 }} 人（查看明细）
                      </el-button>
                    </dd>
                  </div>
                </dl>
                <div v-if="orderDetail.PhotoUrl" class="order-detail-photo order-detail-photo--inline">
                  <h4 class="order-detail-card__title">证件照</h4>
                  <oss-el-image
                    class="order-detail-photo__img"
                    :src="orderDetail.PhotoUrl"
                    fit="cover"
                    :preview-src-list="orderDetail.PhotoUrl ? [orderDetail.PhotoUrl] : []" />
                  <p class="order-detail-photo__hint">点击查看大图</p>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane name="guardians">
            <span slot="label">
              监护人
              <el-badge
                :value="orderDetail.GuardianCount || 0"
                :hidden="!(orderDetail.GuardianCount > 0)"
                class="order-detail-tab-badge"
                type="primary" />
            </span>
            <div class="order-detail-pane">
              <el-table
                v-if="orderDetail.Guardians && orderDetail.Guardians.length"
                :data="orderDetail.Guardians"
                size="small"
                border
                stripe>
                <el-table-column type="index" label="#" width="50" align="center" />
                <el-table-column prop="Name" label="姓名" min-width="100" show-overflow-tooltip />
                <el-table-column prop="Phone" label="电话" min-width="130" show-overflow-tooltip />
                <el-table-column prop="Relation" label="关系" min-width="90" align="center" />
              </el-table>
              <el-empty
                v-else
                :image-size="72"
                description="该订单暂无监护人信息" />
            </div>
          </el-tab-pane>

          <el-tab-pane name="refund">
            <span slot="label">
              退款记录
              <el-badge
                :value="(orderDetail.RefundRecords && orderDetail.RefundRecords.length) || 0"
                :hidden="!(orderDetail.RefundRecords && orderDetail.RefundRecords.length)"
                class="order-detail-tab-badge"
                type="warning" />
            </span>
            <div class="order-detail-pane">
              <div v-if="canRefundOrder(orderDetail)" class="order-detail-actions order-detail-actions--top">
                <el-button type="danger" size="small" plain @click="openRefundDialog(orderDetail)">发起退款</el-button>
              </div>
              <el-table
                v-if="orderDetail.RefundRecords && orderDetail.RefundRecords.length"
                :data="orderDetail.RefundRecords"
                size="small"
                border
                stripe>
                <el-table-column prop="CreateTime" label="时间" min-width="150" />
                <el-table-column prop="RefundAmount" label="金额" width="88" align="center" />
                <el-table-column label="操作人" width="100" show-overflow-tooltip>
                  <template slot-scope="s">{{ s.row.OperatorName || '—' }}</template>
                </el-table-column>
                <el-table-column prop="Remark" label="备注" min-width="120" show-overflow-tooltip />
                <el-table-column prop="OutRequestNo" label="请求号" min-width="140" show-overflow-tooltip />
              </el-table>
              <el-empty
                v-else
                :image-size="72"
                description="暂无退款记录" />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="orderDetail && canRefundOrder(orderDetail)"
          type="danger"
          plain
          size="small"
          @click="openRefundDialog(orderDetail)">
          发起退款
        </el-button>
        <el-button size="small" @click="orderDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="订单退款" :visible.sync="refundDialogVisible" width="460px" append-to-body>
      <el-form v-if="refundForm.orderId" label-width="96px" size="small">
        <el-form-item label="订单号">{{ refundForm.orderNo }}</el-form-item>
        <el-form-item label="实付金额">{{ refundForm.paidAmount }}</el-form-item>
        <el-form-item label="已退金额">{{ refundForm.refundedAmount }}</el-form-item>
        <el-form-item label="可退金额">{{ refundForm.remainAmount }}</el-form-item>
        <el-form-item label="本次退款" required>
          <el-input-number
            v-model="refundForm.amount"
            :min="0.01"
            :max="refundForm.remainAmount"
            :precision="2"
            :step="0.01"
            style="width: 140px;" />
          <el-button type="text" @click="refundForm.amount = refundForm.remainAmount">退全部</el-button>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="refundForm.remark" type="textarea" :rows="2" placeholder="选填" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="refundDialogVisible = false">取消</el-button>
        <el-button type="danger" :loading="refundSubmitting" @click="submitRefund">确认退款</el-button>
      </span>
    </el-dialog>

    <el-upload
      style="display: none;"
      name="Files"
      :data="$ossUploadData('BadgeOrder')"
      class="badge-order-quill-upload"
      :on-success="quillImageSuccess"
      accept=".png,.jpg,.jpeg"
      :action="BaseApiUrl + '/images/Upload/Pic'">
      <i class="el-icon-upload" />
    </el-upload>

    <el-dialog title="图片预览" :visible.sync="imagePreviewVisible" append-to-body width="520px">
      <img v-if="imagePreviewUrl" :src="imagePreviewUrl" class="image-preview-full" alt="" />
    </el-dialog>

    <el-dialog
      :title="stylePreviewTemplate ? '校徽效果实时调试 · ' + stylePreviewTemplate.Name : '校徽效果实时调试'"
      :visible.sync="styleTemplatePreviewVisible"
      append-to-body
      width="950px"
      @closed="styleTemplatePreviewRow = null">
      <el-row :gutter="24">
        <!-- 左侧：模拟输入与测试控制器 -->
        <el-col :span="10">
          <div class="mock-control-panel">
            <h4 class="mock-control-title"><i class="el-icon-edit"></i> 模拟数据调试</h4>
            <el-form label-position="top" size="small" class="mock-control-form">
              <el-form-item label="所属班级">
                <el-input v-model="stylePreviewMock.className" placeholder="请输入班级，如：五年级1班" />
              </el-form-item>
              <el-form-item label="学生姓名">
                <el-input v-model="stylePreviewMock.studentName" placeholder="请输入姓名" />
              </el-form-item>
              <el-form-item label="校徽编号">
                <el-input v-model="stylePreviewMock.badgeNo" placeholder="请输入编号" />
              </el-form-item>
              <el-form-item label="学生头像">
                <div class="mock-avatar-uploader-row">
                  <el-upload
                    class="preview-photo-upload"
                    name="Files"
                    :data="$ossUploadData('BadgeOrderPreview')"
                    :action="uploadUrl"
                    :show-file-list="false"
                    accept=".png,.jpg,.jpeg"
                    :on-success="res => onStylePreviewPhotoSuccess(res)">
                    <el-button size="mini" type="primary" plain icon="el-icon-upload2">上传证件照</el-button>
                  </el-upload>
                  <el-button size="mini" type="text" @click="useSamplePreviewPhoto('style')">载入案例示例照</el-button>
                </div>
              </el-form-item>
              <el-form-item label="切换其它模板">
                <el-select v-model="stylePreviewTemplateId" placeholder="选择其他样式模板" style="width: 100%;">
                  <el-option v-for="t in templates" :key="t.Id" :label="t.Name" :value="t.Id" />
                </el-select>
              </el-form-item>
            </el-form>
            <div class="mock-control-tip">
              <i class="el-icon-info"></i> 温馨提示：更改班级、姓名、编号、上传头像或切换模板后，右侧校徽生成画布将实时呈现渲染效果。
            </div>
          </div>
        </el-col>
        <!-- 右侧：实时画布渲染 -->
        <el-col :span="14" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <div class="mock-canvas-wrapper" v-if="stylePreviewTemplate">
            <badge-style-preview
              :key="'dlg-' + stylePreviewTemplate.Id + '-' + stylePreviewTemplate.CanvasWidth"
              :canvas-width="stylePreviewTemplate.CanvasWidth"
              :canvas-height="stylePreviewTemplate.CanvasHeight"
              :background-url="stylePreviewTemplate.PreviewImageUrl"
              :layers-json="stylePreviewTemplate.LayersJson"
              :resolved="stylePreviewMock"
              :max-width="480" />
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </section>
</template>

<script>
/**
 * 校徽订购管理页：全局配置、收集字段、样式模板、套餐、订购记录。
 * 最后更新：2026-05-27
 */
import Quill from 'quill'
import ImageResize from '@taoqf/quill-image-resize-module'
import { BaseApiUrl } from '../../api/base';window.Quill = Quill
Quill.register('modules/imageResize', ImageResize)
import {
  productDetailTemplateOptions,
  getProductDetailTemplateHtml,
  resolveProductDetailHtmlImages,
  stripProductDetailHtmlImages,
  normalizeProductDetailHtml,
  needsProductDetailSample,
  resolveProductDetailTemplateKey
} from './productDetailTemplates'
import {
  collectFieldPresets,
  getPresetByKey,
  getPresetLabel,
  getFieldTypeLabel,
  parseFieldExtras,
  buildRuleJson,
  getDefaultCollectFieldSortNo,
  getCollectFieldAdminRemark,
  getDefaultCollectFields
} from './collectFieldPresets'
import {
  defaultBadgeLayersJson,
  defaultBadgeBackgroundUrl,
  badgeCanvasWidth,
  badgeCanvasHeight,
  previewSamplePhotoUrl,
  templatePreviewMockDefault,
  normalizeDefaultBadgeBackgroundUrl,
  needsBadgeLayerMigration,
  getDefaultBadgeLayerMap,
  stringifyBadgeLayers
} from './badgeStyleLayerDefaults'
import BadgeStylePreview from './BadgeStylePreview.vue'
import BadgeOrderStatistics from './BadgeOrderStatistics.vue'
import { badgeOrderGetGlobalConfig, badgeOrderGetAliPayConfigOptions, badgeOrderSaveGlobalConfig, badgeOrderGetCollectFields, badgeOrderSaveCollectField, badgeOrderGetStyleTemplates, badgeOrderSaveStyleTemplate, badgeOrderDeleteStyleTemplate, badgeOrderSetDefaultStyleTemplate, badgeOrderGetPackages, badgeOrderSavePackage, badgeOrderDeletePackage, badgeOrderGetOrders, badgeOrderGetOrderDetail, badgeOrderExportOrdersExcel, badgeOrderExportOrdersListExcel, badgeOrderRefund, badgeOrderBatchCleanupPendingOrders } from '../../api/modules/badge-order';/** Quill 富文本编辑器工具栏（产品详情 HTML） */
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{ header: 1 }, { header: 2 }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ size: ['small', false, 'large', 'huge'] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ align: [] }],
  ['clean'],
  ['image', 'link']
]

export default {
  name: 'BadgeOrderAdmin',
  components: { BadgeStylePreview, BadgeOrderStatistics },
  data() {
    return {
      BaseApiUrl,
      uploadUrl: BaseApiUrl + '/images/Upload/Pic',
      imagePreviewVisible: false,
      imagePreviewUrl: '',
      editorOption: {
        placeholder: '请输入产品详情，支持图文排版',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image(value) {
                if (value) {
                  const el = document.querySelector('.badge-order-quill-upload .el-icon-upload')
                  if (el) el.click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          },
          imageResize: {
            modules: ['Resize', 'DisplaySize']
          }
        }
      },
      productDetailTemplateOptions,
      defaultBadgeBackgroundUrl,
      productDetailTemplateKey: '',
      activeTab: 'config',
      configCollapseActive: ['core', 'payment', 'display', 'detail'],
      qtyOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      guardianMinOptions: [0, 1, 2, 3, 4, 5],
      guardianMaxOptions: [1, 2, 3, 4, 5],
      dayOptions: Array.from({ length: 31 }, (_, i) => i + 1),
      config: {
        Enabled: false,
        FirstBadgeFree: false,
        DefaultMinQty: 3,
        FirstTimeMinQty: 1,
        MinGuardianCount: 0,
        MaxGuardianCount: 1,
        ApplyMode: 1,
        ApplyDayStart: 1,
        ApplyDayEnd: 31,
        PlatformAliPayConfigId: null,
        TitleName: '',
        ShareTitle: '',
        ShareCoverUrl: '',
        PosterUrl: '',
        ProductImageUrl: '',
        ProductDetailHtml: ''
      },
      configSaving: false,
      fields: [],
      templates: [],
      packages: [],
      fieldDialogVisible: false,
      fieldForm: {
        Id: null,
        presetKey: '',
        SortNo: 1,
        Required: true,
        allowParentFill: false,
        photoSpec: ''
      },
      templateDialogVisible: false,
      showLivePreview: false, // 是否展开模拟效果预览卡片
      templateForm: {},
      packageDialogVisible: false,
      packageForm: {},
      orderQuery: { keyword: '', payStatus: null },
      orderDateRange: null,
      orders: [],
      orderLoading: false,
      orderPage: { page: 1, pageSize: 10, total: 0 },
      orderSelection: [],
      orderCleanupLoading: false,
      orderExportLoading: false,
      orderListExportLoading: false,
      pendingOrderExpireMinutes: 30,
      orderDetailVisible: false,
      orderDetailLoading: false,
      orderDetail: null,
      orderDetailTab: 'basic',
      refundDialogVisible: false,
      refundSubmitting: false,
      refundForm: {
        orderId: null,
        orderNo: '',
        paidAmount: 0,
        refundedAmount: 0,
        remainAmount: 0,
        amount: 0,
        remark: ''
      },
      stylePreviewMock: { ...templatePreviewMockDefault },
      stylePreviewTemplateId: null,
      styleTemplatePreviewVisible: false,
      styleTemplatePreviewRow: null,
      templatePreviewMock: { ...templatePreviewMockDefault },
      aliPayConfigOptions: []
    }
  },
  computed: {
    collectFieldPresets() {
      return collectFieldPresets
    },
    navItems() {
      return [
        { key: 'config', label: '基础设置', hint: '开关、支付与展示', icon: 'el-icon-setting' },
        { key: 'fields', label: '收集字段', hint: '家长办理表单', icon: 'el-icon-tickets', badge: this.enabledFieldsCount || null },
        { key: 'templates', label: '样式模板', hint: '校徽底图与排版', icon: 'el-icon-picture-outline', badge: this.templates.length || null },
        { key: 'packages', label: '校徽套餐', hint: '款式与定价', icon: 'el-icon-goods', badge: this.packages.length || null },
        { key: 'orders', label: '订购记录', hint: '查询与退款', icon: 'el-icon-s-order', badge: this.orderPage.total || null },
        { key: 'statistics', label: '订购统计', hint: '数据概览', icon: 'el-icon-data-analysis' }
      ]
    },
    overviewCards() {
      const enabledLabel = this.config.Enabled ? '已启用' : '未启用'
      return [
        { key: 'status', tab: 'config', label: '服务状态', value: enabledLabel, icon: 'el-icon-switch-button', tone: this.config.Enabled ? 'success' : 'muted' },
        { key: 'fields', tab: 'fields', label: '收集字段', value: this.enabledFieldsCount, icon: 'el-icon-tickets', tone: 'primary' },
        { key: 'packages', tab: 'packages', label: '在售套餐', value: this.enabledPackageCount, icon: 'el-icon-goods', tone: 'accent' },
        { key: 'orders', tab: 'orders', label: '订购记录', value: this.orderPage.total, icon: 'el-icon-s-order', tone: 'primary' }
      ]
    },
    enabledPackageCount() {
      return (this.packages || []).filter(p => p.Enabled).length
    },
    defaultStyleTemplate() {
      return (this.templates || []).find(t => t.IsDefault) || this.templates[0] || null
    },
    /** 新增套餐时的默认序号（当前最大序号 + 1） */
    nextPackageSortNo() {
      const list = this.packages || []
      if (!list.length) return 1
      return Math.max.apply(null, list.map(p => p.SortNo || 0)) + 1
    },
    stylePreviewTemplate() {
      if (!this.stylePreviewTemplateId || !this.templates.length) return null
      return this.templates.find(t => t.Id === this.stylePreviewTemplateId) || this.templates[0]
    },
    packagePreviewTemplate() {
      if (!this.packageForm.StyleTemplateId) return null
      return this.templates.find(t => t.Id === this.packageForm.StyleTemplateId)
    },
    sortedFields() {
      return (this.fields || []).slice().sort((a, b) => {
        const sa = a.SortNo || 0
        const sb = b.SortNo || 0
        if (sa !== sb) return sa - sb
        const ea = getDefaultCollectFieldSortNo(a.FieldKey)
        const eb = getDefaultCollectFieldSortNo(b.FieldKey)
        if (ea != null && eb != null) return ea - eb
        if (ea != null) return -1
        if (eb != null) return 1
        return (a.Id || 0) - (b.Id || 0)
      })
    },
    enabledFieldsCount() {
      return (this.fields || []).filter(f => f.Enabled).length
    },
    /** 预设与已启用字段合并，用于矩阵表展示 */
    fieldMatrixRows() {
      return collectFieldPresets.map(preset => {
        const field = this.fields.find(f => f.FieldKey === preset.key)
        return {
          preset,
          field: field || null,
          added: !!field,
          enabled: !!(field && field.Enabled)
        }
      })
    },
    configFormRules() {
      if (this.config.ApplyMode !== 1) return {}
      return {
        PlatformAliPayConfigId: [
          {
            validator: (rule, value, callback) => this.validateAliPayConfigId(value, callback),
            trigger: 'blur'
          }
        ]
      }
    },
    orderDetailDialogTitle() {
      if (!this.orderDetail) return '订单详情'
      const name = this.orderDetail.StudentName || ''
      const no = this.orderDetail.OrderNo || ''
      if (name && no) return `订单详情 · ${name}（${no}）`
      if (no) return `订单详情 · ${no}`
      return '订单详情'
    }
  },
  watch: {
    'config.ApplyMode'(mode) {
      this.$nextTick(() => {
        const form = this.$refs.configForm
        if (form) form.clearValidate('PlatformAliPayConfigId')
      })
      if (mode !== 1) {
        this.normalizeConfigAliPayId()
      }
    },
    activeTab(tab) {
      if (tab === 'orders') this.loadOrders(1)
    }
  },
  mounted() {
    this.applyRouteTab()
    this.loadAll()
  },
  methods: {
    /** 切换功能面板 */
    switchTab(tab) {
      if (!tab || this.activeTab === tab) return
      this.activeTab = tab
    },
    /** 支持 ?tab=statistics 打开指定 Tab */
    applyRouteTab() {
      const tab = this.$route.query.tab
      if (tab && ['config', 'fields', 'templates', 'packages', 'orders', 'statistics'].includes(tab)) {
        this.activeTab = tab
      }
    },
    /** ---------- 初始化 ---------- */
    async loadAll() {
      await Promise.all([
        this.loadConfig(),
        this.loadAliPayConfigOptions(),
        this.loadFields(),
        this.loadTemplates(),
        this.loadPackages()
      ])
      if (this.activeTab === 'orders') this.loadOrders(1)
    },
    /** ---------- 全局配置 ---------- */
    async loadConfig() {
      const res = await badgeOrderGetGlobalConfig()
      if (res.data.success && res.data.response) {
        this.config = { ...this.config, ...res.data.response }
        if (this.config.MinGuardianCount == null || this.config.MinGuardianCount < 0) {
          this.config.MinGuardianCount = 0
        }
        if (!this.config.MaxGuardianCount || this.config.MaxGuardianCount < 1) {
          this.config.MaxGuardianCount = 1
        }
        if (this.config.MinGuardianCount > this.config.MaxGuardianCount) {
          this.config.MinGuardianCount = this.config.MaxGuardianCount
        }
        this.deferredImageInit('productImage', this.config.ProductImageUrl)
        this.deferredImageInit('shareCover', this.config.ShareCoverUrl)
        this.deferredImageInit('poster', this.config.PosterUrl)
        this.normalizeConfigAliPayId()
        this.applyProductDetailHtmlToEditor(this.config.ProductDetailHtml, true)
        this.productDetailTemplateKey = resolveProductDetailTemplateKey(
          this.config.ProductDetailHtml,
          this.BaseApiUrl
        )
        this.$nextTick(() => {
          // 确保初次加载时页面滚动条处于最顶端，防止富文本编辑器初始化自动聚焦导致下翻
          const container = document.querySelector('.badge-order-admin')
          if (container) container.scrollTop = 0
          window.scrollTo(0, 0)
        })
      }
      this.$nextTick(() => {
        const form = this.$refs.configForm
        if (form) form.clearValidate('PlatformAliPayConfigId')
      })
    },
    normalizeConfigAliPayId() {
      const id = this.config.PlatformAliPayConfigId
      if (!id || Number(id) <= 0) {
        this.config.PlatformAliPayConfigId = null
      }
    },
    async loadAliPayConfigOptions() {
      const res = await badgeOrderGetAliPayConfigOptions()
      if (res.data.success) {
        this.aliPayConfigOptions = res.data.response || []
      }
    },
    aliPayConfigOptionLabel(c) {
      if (!c) return ''
      const name = c.Name || ''
      const appId = c.AppId || ''
      return appId ? name + '（' + appId + '）' : name
    },
    validateAliPayConfigId(value, callback) {
      if (this.config.ApplyMode !== 1) {
        callback()
        return
      }
      if (!value || Number(value) <= 0) {
        callback(new Error('收费模式下请选择支付宝配置'))
        return
      }
      const item = this.aliPayConfigOptions.find(c => c.Id === value)
      if (!item) {
        callback(new Error('请选择有效的支付宝配置'))
        return
      }
      if (!item.Enabled) {
        callback(new Error('该支付宝配置已停用，请更换'))
        return
      }
      callback()
    },
    async saveConfig() {
      const form = this.$refs.configForm
      if (!form) return
      try {
        await form.validate()
      } catch (e) {
        this.$message.warning('请完善必填项后再保存')
        return
      }
      this.configSaving = true
      try {
        this.config.ProductImageUrl = await this.deferredImageEnsure('productImage', { foo: 'BadgeOrderProduct', currentUrl: this.config.ProductImageUrl })
        this.config.ShareCoverUrl = await this.deferredImageEnsure('shareCover', { foo: 'BadgeOrderShareCover', currentUrl: this.config.ShareCoverUrl })
        this.config.PosterUrl = await this.deferredImageEnsure('poster', { foo: 'BadgeOrderPoster', currentUrl: this.config.PosterUrl })
        const payload = {
          ...this.config,
          PlatformAliPayConfigId: this.config.PlatformAliPayConfigId || 0,
          ProductDetailHtml: stripProductDetailHtmlImages(
            this.config.ProductDetailHtml,
            this.BaseApiUrl
          )
        }
        const res = await badgeOrderSaveGlobalConfig(payload)
        if (res.data.success) this.$message.success('保存成功')
        else this.$message.error(res.data.msg || '保存失败')
      } finally {
        this.configSaving = false
      }
    },
    /** ---------- 收集字段 ---------- */
    async loadFields() {
      const res = await badgeOrderGetCollectFields()
      if (res.data.success) this.fields = res.data.response || []
    },
    fieldTypeLabel(fieldType) {
      return getFieldTypeLabel(fieldType)
    },
    isFieldPresetAdded(key) {
      return this.fields.some(f => f.FieldKey === key)
    },
    quickAddField(key) {
      if (this.isFieldPresetAdded(key)) return
      this.fieldForm = {
        Id: null,
        presetKey: key,
        SortNo: this.fields.length + 1,
        Required: key !== 'guardians',
        Enabled: true,
        allowParentFill: false,
        photoSpec: '作为校徽头像，请上传1寸、白底标准证件照'
      }
      this.onFieldPresetChange(key)
      this.fieldDialogVisible = true
    },
    fieldDisplayName(row) {
      return getPresetLabel(row.FieldKey) || row.Title || row.FieldKey
    },
    fieldRemark(row) {
      return getCollectFieldAdminRemark(row)
    },
    /** 未启用字段的默认说明（来自预设规则） */
    fieldPresetDefaultRemark(key) {
      const def = getDefaultCollectFields().find(f => f.FieldKey === key)
      return def ? getCollectFieldAdminRemark(def) : '—'
    },
    /** 字段类型图标 */
    fieldPresetIcon(key) {
      const map = {
        schoolName: 'el-icon-office-building',
        studentName: 'el-icon-user',
        gradeName: 'el-icon-collection-tag',
        className: 'el-icon-school',
        studentNo: 'el-icon-tickets',
        parentPhone: 'el-icon-phone-outline',
        guardians: 'el-icon-s-custom',
        badgeNo: 'el-icon-postcard',
        photo: 'el-icon-camera'
      }
      return map[key] || 'el-icon-edit-outline'
    },
    isFieldPresetUsed(key) {
      if (this.fieldForm.Id && this.fieldForm.presetKey === key) return false
      return this.fields.some(f => f.FieldKey === key)
    },
    onFieldPresetChange(key) {
      const preset = getPresetByKey(key)
      if (!preset) return
      if (key === 'guardians') {
        this.fieldForm.Required = false
      }
      if (key === 'photo' && !this.fieldForm.photoSpec) {
        this.fieldForm.photoSpec = '作为校徽头像，请上传1寸、白底标准证件照'
      }
    },
    openFieldDialog(row) {
      if (row) {
        const ex = parseFieldExtras(row.FieldKey, row.RuleJson, row.AllowParentFill)
        this.fieldForm = {
          Id: row.Id,
          presetKey: row.FieldKey,
          SortNo: row.SortNo,
          Required: row.Required,
          Enabled: row.Enabled !== false,
          allowParentFill: ex.allowParentFill,
          photoSpec: ex.photoSpec || '作为校徽头像，请上传1寸、白底标准证件照'
        }
      } else {
        const nextPreset = collectFieldPresets.find(p => !this.fields.some(f => f.FieldKey === p.key))
        const nextKey = nextPreset ? nextPreset.key : ''
        this.fieldForm = {
          Id: null,
          presetKey: nextKey,
          SortNo: this.fields.length + 1,
          Required: nextKey !== 'guardians',
          Enabled: true,
          allowParentFill: false,
          photoSpec: '作为校徽头像，请上传1寸、白底标准证件照'
        }
      }
      this.fieldDialogVisible = true
    },
    buildFieldSavePayload(enabledOverride) {
      const preset = getPresetByKey(this.fieldForm.presetKey)
      if (!preset) return null
      const enabled = enabledOverride != null ? enabledOverride : this.fieldForm.Enabled !== false
      return {
        Id: this.fieldForm.Id,
        SortNo: this.fieldForm.SortNo,
        FieldKey: preset.key,
        Title: preset.label,
        FieldType: preset.fieldType,
        Required: this.fieldForm.Required,
        AllowParentFill: preset.key === 'badgeNo' ? this.fieldForm.allowParentFill : false,
        RuleJson: buildRuleJson(preset.key, {
          allowParentFill: this.fieldForm.allowParentFill,
          photoSpec: this.fieldForm.photoSpec
        }),
        Enabled: enabled
      }
    },
    buildFieldPayloadFromRow(field, enabled) {
      const preset = getPresetByKey(field.FieldKey)
      return {
        Id: field.Id,
        SortNo: field.SortNo,
        FieldKey: field.FieldKey,
        Title: field.Title || (preset && preset.label) || field.FieldKey,
        FieldType: field.FieldType,
        Required: field.Required,
        AllowParentFill: field.AllowParentFill,
        RuleJson: field.RuleJson,
        Enabled: enabled
      }
    },
    async saveField() {
      if (!this.fieldForm.presetKey) {
        this.$message.warning('请选择字段类型')
        return
      }
      const payload = this.buildFieldSavePayload()
      if (!payload) return
      const res = await badgeOrderSaveCollectField(payload)
      if (res.data.success) {
        this.$message.success('保存成功')
        this.fieldDialogVisible = false
        this.loadFields()
      } else this.$message.error(res.data.msg)
    },
    async setFieldEnabled(field, enabled) {
      if (!field || !field.Id) return
      const name = this.fieldDisplayName(field)
      try {
        if (!enabled) {
          await this.$confirm(
            `确认禁用「${name}」？禁用后家长办理页将不再展示该字段，可随时重新启用。`,
            '禁用字段',
            { type: 'warning' }
          )
        }
        const payload = this.buildFieldPayloadFromRow(field, enabled)
        const res = await badgeOrderSaveCollectField(payload)
        if (res.data.success) {
          this.$message.success(enabled ? '已启用' : '已禁用')
          this.loadFields()
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      } catch (e) { /* 用户取消 */ }
    },
    /** ---------- 样式模板 ---------- */
    async loadTemplates() {
      const res = await badgeOrderGetStyleTemplates()
      if (res.data.success) {
        this.templates = (res.data.response || []).map(t => this.normalizeTemplateRow(t))
        if (this.templates.length && !this.stylePreviewTemplateId) {
          this.stylePreviewTemplateId = this.templates[0].Id
        }
      }
    },
    /** 统一底图地址，便于静态资源与预览加载 */
    normalizeTemplateRow(row) {
      if (!row) return row
      const item = { ...row }
      item.PreviewImageUrl = normalizeDefaultBadgeBackgroundUrl(item.PreviewImageUrl || defaultBadgeBackgroundUrl)
      if (
        needsBadgeLayerMigration(
          item.CanvasWidth,
          item.CanvasHeight,
          item.LayersJson,
          item.PreviewImageUrl
        )
      ) {
        item.CanvasWidth = badgeCanvasWidth
        item.CanvasHeight = badgeCanvasHeight
        item.LayersJson = defaultBadgeLayersJson
      }
      return item
    },
    packageStyleThumbUrl(pkg) {
      if (!pkg || !pkg.StyleTemplateId) return ''
      const tpl = this.templates.find(t => t.Id === pkg.StyleTemplateId)
      return (tpl && tpl.PreviewImageUrl) || pkg.StylePreviewImageUrl || ''
    },
    /** 打开样式模板大图预览弹窗 */
    openStyleTemplatePreview(row) {
      if (!row) return
      this.stylePreviewTemplateId = row.Id
      this.styleTemplatePreviewRow = this.normalizeTemplateRow(row)
      this.styleTemplatePreviewVisible = true
    },
    openPackageStylePreview(pkg) {
      if (!pkg || !pkg.StyleTemplateId) {
        this.$message.info('请先为套餐选择样式模板')
        return
      }
      const tpl = this.templates.find(t => t.Id === pkg.StyleTemplateId)
      if (!tpl) {
        this.$message.warning('未找到关联的样式模板')
        return
      }
      this.openStyleTemplatePreview(tpl)
    },
    onStylePreviewPhotoSuccess(res) {
      if (res && res.success) {
        this.stylePreviewMock.photoUrl = res.response || ''
      } else {
        this.$message.error((res && res.msg) || '上传失败')
      }
    },
    onTemplatePreviewPhotoSuccess(res) {
      if (res && res.success) {
        this.templatePreviewMock.photoUrl = res.response || ''
      } else {
        this.$message.error((res && res.msg) || '上传失败')
      }
    },
    useSamplePreviewPhoto(target) {
      const mock = target === 'style' ? this.stylePreviewMock : this.templatePreviewMock
      mock.photoUrl = previewSamplePhotoUrl
      this.$message.success('已载入案例示例照')
    },
    openTemplateDialog(row) {
      this.templateForm = row
        ? this.normalizeTemplateRow({ ...row })
        : {
          Name: '横版校徽样式',
          PreviewImageUrl: defaultBadgeBackgroundUrl,
          CanvasWidth: badgeCanvasWidth,
          CanvasHeight: badgeCanvasHeight,
          LayersJson: defaultBadgeLayersJson,
          Enabled: true,
          IsDefault: !this.templates.length
        }
      if (!row && this.templateForm.IsDefault === undefined) {
        this.templateForm.IsDefault = false
      }
      this.templatePreviewMock = { ...templatePreviewMockDefault }
      this.templateDialogVisible = true
    },
    /** 恢复案例图默认画布与图层（需保存模板才写入库） */
    restoreTemplateCaseLayout() {
      this.templateForm.PreviewImageUrl = defaultBadgeBackgroundUrl
      this.templateForm.CanvasWidth = badgeCanvasWidth
      this.templateForm.CanvasHeight = badgeCanvasHeight
      this.templateForm.LayersJson = stringifyBadgeLayers(getDefaultBadgeLayerMap())
      this.templatePreviewMock = { ...templatePreviewMockDefault }
      this.$message.success('已恢复案例布局，请保存模板')
    },
    async saveTemplate() {
      const payload = this.normalizeTemplateRow({ ...this.templateForm })
      payload.IsDefault = !!this.templateForm.IsDefault
      const res = await badgeOrderSaveStyleTemplate(payload)
      if (res.data.success) {
        this.$message.success('保存成功')
        this.templateDialogVisible = false
        this.loadTemplates()
        this.loadPackages()
      } else this.$message.error(res.data.msg)
    },
    async removeTemplate(id) {
      const usedPackages = (this.packages || []).filter(p => p.StyleTemplateId === id)
      const usedCount = usedPackages.length
      const usedNames = usedPackages.map(p => p.Name).filter(Boolean).join('、')
      const confirmMsg = usedCount > 0
        ? `该模板正被 ${usedCount} 个套餐使用${usedNames ? `（${usedNames}）` : ''}。删除后将自动切换为默认样式模板，确认删除？`
        : '确认删除该样式模板？'
      try {
        await this.$confirm(confirmMsg, '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      const res = await badgeOrderDeleteStyleTemplate(id)
      if (res.data.success) {
        this.$message.success(usedCount > 0 ? '已删除，相关套餐已切换为默认样式' : '已删除')
        this.loadTemplates()
        if (usedCount > 0) this.loadPackages()
      } else {
        this.$message.error(res.data.msg || '删除失败')
      }
    },
    async setDefaultTemplate(row) {
      if (!row || !row.Id || row.IsDefault) return
      const res = await badgeOrderSetDefaultStyleTemplate(row.Id)
      if (res.data.success) {
        this.$message.success('已设为默认模板')
        this.loadTemplates()
        this.loadPackages()
      } else {
        this.$message.error(res.data.msg || '操作失败')
      }
    },
    /** ---------- 套餐 ---------- */
    async loadPackages() {
      const res = await badgeOrderGetPackages()
      if (res.data.success) this.packages = res.data.response || []
    },
    openPackageDialog(row) {
      this.packageForm = row
        ? { ...row }
        : {
          Name: '',
          StyleTemplateId: (this.defaultStyleTemplate && this.defaultStyleTemplate.Id) || 0,
          ModelName: '',
          UnitPrice: 0,
          SortNo: this.nextPackageSortNo,
          Enabled: true
        }
      this.packageDialogVisible = true
    },
    async savePackage() {
      const payload = { ...this.packageForm }
      if (!payload.SortNo || payload.SortNo < 1) {
        payload.SortNo = this.nextPackageSortNo
      }
      const res = await badgeOrderSavePackage(payload)
      if (res.data.success) {
        this.$message.success('保存成功')
        this.packageDialogVisible = false
        this.loadPackages()
      } else this.$message.error(res.data.msg)
    },
    async removePackage(id) {
      try {
        await this.$confirm('确认移除该套餐？移除后家长端将不再展示。', '提示', {
          type: 'warning',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
      } catch (e) {
        return
      }
      const res = await badgeOrderDeletePackage(id)
      if (res.data.success) {
        this.$message.success('已移除')
        this.loadPackages()
      } else {
        this.$message.error(res.data.msg || '移除失败')
      }
    },
    /** ---------- 订购记录 ---------- */
    /** 组装列表/导出查询参数 */
    buildOrderListParams(extra) {
      const params = Object.assign({
        keyword: this.orderQuery.keyword || undefined
      }, extra || {})
      if (this.orderQuery.payStatus !== null && this.orderQuery.payStatus !== undefined && this.orderQuery.payStatus !== '') {
        params.payStatus = this.orderQuery.payStatus
      }
      if (this.orderDateRange && this.orderDateRange.length === 2) {
        params.dateStart = this.orderDateRange[0]
        params.dateEnd = this.orderDateRange[1]
      }
      return params
    },
    async loadOrders(page) {
      this.orderLoading = true
      this.orderPage.page = page
      try {
        const res = await badgeOrderGetOrders(this.buildOrderListParams({
          page,
          pageSize: this.orderPage.pageSize
        }))
        if (res.data.success && res.data.response) {
          this.orders = res.data.response.data || []
          this.orderPage.total = res.data.response.dataCount || 0
        }
      } finally {
        this.orderLoading = false
      }
    },
    formatOrderExportTimeStamp() {
      const d = new Date()
      const p = n => (n < 10 ? '0' + n : '' + n)
      return '' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds())
    },
    async parseOrderExportBlobErrorMsg(blob) {
      try {
        const text = await new Response(blob).text()
        const j = JSON.parse(text)
        return j.msg || j.message || j.Message || ''
      } catch (e) {
        return ''
      }
    },
    /** 按当前筛选导出厂家制作单 ZIP */
    async exportOrders() {
      try {
        const res = await badgeOrderExportOrdersExcel(this.buildOrderListParams())
        if (!res.data || !(res.data instanceof Blob) || res.data.size === 0) {
          this.$message.error('导出数据为空')
          return
        }
        const contentType = res.headers && res.headers['content-type']
        if (contentType && contentType.indexOf('application/json') >= 0) {
          const msg = await this.parseOrderExportBlobErrorMsg(res.data)
          this.$message.error(msg || '导出失败')
          return
        }
        const blob = new Blob([res.data], { type: 'application/zip' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', '校徽厂家制作单_' + this.formatOrderExportTimeStamp() + '.zip')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (error) {
        const blob = error.response && error.response.data
        if (blob instanceof Blob) {
          const msg = await this.parseOrderExportBlobErrorMsg(blob)
          this.$message.error(msg || '导出失败')
          return
        }
        this.$message.error('导出失败')
      }
    },
    /** 按当前筛选导出订购记录 Excel（不含证件照） */
    async exportOrderList() {
      try {
        const res = await badgeOrderExportOrdersListExcel(this.buildOrderListParams())
        if (!res.data || !(res.data instanceof Blob) || res.data.size === 0) {
          this.$message.error('导出数据为空')
          return
        }
        const contentType = res.headers && res.headers['content-type']
        if (contentType && contentType.indexOf('application/json') >= 0) {
          const msg = await this.parseOrderExportBlobErrorMsg(res.data)
          this.$message.error(msg || '导出失败')
          return
        }
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', '校徽订购记录_' + this.formatOrderExportTimeStamp() + '.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (error) {
        const blob = error.response && error.response.data
        if (blob instanceof Blob) {
          const msg = await this.parseOrderExportBlobErrorMsg(blob)
          this.$message.error(msg || '导出失败')
          return
        }
        this.$message.error('导出失败')
      }
    },
    payStatusText(s) {
      return { 0: '待支付', 1: '已支付', 2: '失败', 3: '已关闭' }[s] || s
    },
    payStatusTagType(s) {
      // 根据支付状态获取 El-Tag 的主题样式
      return { 0: 'warning', 1: 'success', 2: 'danger', 3: 'info' }[s] || 'info'
    },
    orderStatusText(s) {
      return {
        10: '待支付',
        20: '待生产',
        30: '生产中',
        40: '已完成',
        50: '已取消',
        60: '部分退款',
        70: '全额退款'
      }[s] || s
    },
    /** 列表「实付（元）」列 */
    orderPaidAmountText(row) {
      if (!row) return 0
      const amount = Number(row.PaidAmount)
      return Number.isFinite(amount) ? amount : 0
    },
    orderRefundRemain(row) {
      if (!row || row.PayStatus !== 1) return 0
      const pay = Number(row.PaidAmount) || 0
      const refunded = Number(row.RefundAmount) || 0
      const remain = pay - refunded
      return remain > 0 ? Math.round(remain * 100) / 100 : 0
    },
    canRefundOrder(row) {
      return row && row.PayStatus === 1 && this.orderRefundRemain(row) > 0
    },
    openRefundDialog(row) {
      if (!this.canRefundOrder(row)) {
        this.$message.warning('该订单不可退款')
        return
      }
      const remain = this.orderRefundRemain(row)
      this.refundForm = {
        orderId: row.Id,
        orderNo: row.OrderNo,
        paidAmount: row.PaidAmount,
        refundedAmount: row.RefundAmount || 0,
        remainAmount: remain,
        amount: remain,
        remark: ''
      }
      this.refundDialogVisible = true
    },
    async submitRefund() {
      const form = this.refundForm
      if (!form.orderId) return
      const amount = Number(form.amount)
      if (!amount || amount <= 0) {
        this.$message.warning('请输入退款金额')
        return
      }
      if (amount > form.remainAmount) {
        this.$message.warning('退款金额不能超过可退余额')
        return
      }
      try {
        await this.$confirm(
          `确认对订单 ${form.orderNo} 退款 ${amount} 元？`,
          '确认退款',
          { type: 'warning' }
        )
      } catch (e) {
        return
      }
      this.refundSubmitting = true
      try {
        const res = await badgeOrderRefund({
          OrderId: form.orderId,
          RefundAmount: amount,
          Remark: form.remark || '管理端退款'
        })
        if (res.data.success) {
          this.$message.success(res.data.msg || '退款成功')
          this.refundDialogVisible = false
          await this.loadOrders(this.orderPage.page)
          if (this.orderDetailVisible && this.orderDetail && this.orderDetail.Id === form.orderId) {
            await this.viewOrder(form.orderId)
          }
        } else {
          this.$message.error(res.data.msg || '退款失败')
        }
      } finally {
        this.refundSubmitting = false
      }
    },
    /** 待支付且已超过指定分钟数 */
    isPendingOrderExpired(row) {
      if (!row || row.PayStatus !== 0 || !row.CreateTime) return false
      const t = new Date(String(row.CreateTime).replace(/-/g, '/')).getTime()
      if (Number.isNaN(t)) return false
      return Date.now() - t >= this.pendingOrderExpireMinutes * 60 * 1000
    },
    canSelectPendingOrder(row) {
      return this.isPendingOrderExpired(row)
    },
    onOrderSelectionChange(rows) {
      this.orderSelection = rows || []
    },
    async batchCleanupSelectedOrders() {
      if (!this.orderSelection.length) return
      try {
        await this.$confirm(
          `确认清理选中的 ${this.orderSelection.length} 笔超时待支付订单？`,
          '批量清理',
          { type: 'warning' }
        )
      } catch (e) {
        return
      }
      await this.runBatchOrderCleanup(this.orderSelection.map(r => r.Id))
    },
    /** 单条清理超时待支付订单 */
    async cleanupSingleOrder(row) {
      if (!row || !this.canSelectPendingOrder(row)) return
      try {
        await this.$confirm(
          `确认清理订单 ${row.OrderNo}？清理后标记为已关闭。`,
          '清理订单',
          { type: 'warning' }
        )
      } catch (e) {
        return
      }
      await this.runBatchOrderCleanup([row.Id])
    },
    async batchCleanupAllExpiredOrders() {
      try {
        await this.$confirm(
          `将清理全部超过 ${this.pendingOrderExpireMinutes} 分钟仍未支付的订单（标记为已关闭），是否继续？`,
          '批量清理',
          { type: 'warning' }
        )
      } catch (e) {
        return
      }
      await this.runBatchOrderCleanup([])
    },
    async runBatchOrderCleanup(orderIds) {
      this.orderCleanupLoading = true
      try {
        const res = await badgeOrderBatchCleanupPendingOrders({
          OrderIds: orderIds,
          Minutes: this.pendingOrderExpireMinutes
        })
        if (res.data.success) {
          this.$message.success(res.data.msg || '清理完成')
          this.orderSelection = []
          const table = this.$refs.orderTable
          if (table && table.clearSelection) table.clearSelection()
          await this.loadOrders(this.orderPage.page)
        } else {
          this.$message.error(res.data.msg || '清理失败')
        }
      } finally {
        this.orderCleanupLoading = false
      }
    },
    async viewOrder(id) {
      this.orderDetailLoading = true
      try {
        const res = await badgeOrderGetOrderDetail(id)
        if (res.data.success) {
          this.orderDetail = res.data.response
          this.orderDetailTab = 'basic'
          this.orderDetailVisible = true
        }
      } finally {
        this.orderDetailLoading = false
      }
    },
    onOrderDetailClosed() {
      this.orderDetail = null
      this.orderDetailTab = 'basic'
    },
    /** ---------- 图片与富文本 ---------- */
    /** 静态资源完整 URL（列表缩略图、预览弹窗等） */
    fullImgUrl(url) {
      if (!url) return ''
      if (url.startsWith('http://') || url.startsWith('https://')) return url
      if (url.indexOf('/static/') === 0) return url
      if (url.indexOf('/badge-order/') === 0) {
        if (process.env.NODE_ENV === 'development') return url
        return this.$resolveImageSrc(url)
      }
      return this.$resolveImageSrc(url.indexOf('/') === 0 ? url : '/' + url)
    },
    beforeConfigImageUpload(file) {
      const ok = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'].includes(file.type)
      if (!ok) this.$message.error('仅支持 JPG / PNG / WEBP 格式')
      return ok
    },
    handleConfigImageChange(field, key, foo, file) {
      this.deferredImageChange(key, file, { foo, savedUrl: this.config[field] })
    },
    removeConfigImage(field, key) {
      if (key) this.deferredImageRevoke(key)
      this.config[field] = ''
    },
    previewConfigImage(url) {
      this.imagePreviewUrl = this.fullImgUrl(url)
      this.imagePreviewVisible = true
    },
    quillImageSuccess(response) {
      if (!response.success) {
        this.$message.error(response.msg || '图片上传失败')
        return
      }
      const quill = this.$refs.productDetailQuill && this.$refs.productDetailQuill.quill
      if (!quill) return
      const pos = quill.getSelection() ? quill.getSelection().index : quill.getLength()
      quill.insertEmbed(pos, 'image', this.$resolveImageSrc(response.response))
    },
    applyProductDetailHtmlToEditor(html, notifyAutoFix) {
      const needFix = needsProductDetailSample(html || '')
      const normalized = normalizeProductDetailHtml(html || '', this.BaseApiUrl)
      this.$nextTick(() => {
        this.syncProductDetailQuillHtml(normalized)
        this.config.ProductDetailHtml = normalized
      })
      if (notifyAutoFix && needFix) {
        this.$message.info('已自动补充校徽示例图，请点击「保存配置」')
      }
    },
    /** 全量替换 Quill 内容（单参数 dangerouslyPasteHTML 为覆盖，避免与 v-model 重复粘贴） */
    syncProductDetailQuillHtml(html) {
      const editor = this.$refs.productDetailQuill
      if (!editor || !editor.quill) return
      if (!html) {
        editor.quill.setText('')
        editor._content = ''
        return
      }
      // 使用 silent 参数防止 Quill 编辑器强行聚焦导致页面自动滚动
      editor.quill.clipboard.dangerouslyPasteHTML(html, 'silent')
      editor._content = html
    },
    async onProductDetailTemplateChange(key) {
      if (!key) return
      const html = getProductDetailTemplateHtml(key)
      if (!html) {
        this.productDetailTemplateKey = ''
        return
      }
      const hasContent = (this.config.ProductDetailHtml || '').replace(/<[^>]+>/g, '').trim()
      if (hasContent) {
        try {
          await this.$confirm('载入预设将覆盖当前产品说明文案，是否继续？', '提示', { type: 'warning' })
        } catch (e) {
          this.productDetailTemplateKey = resolveProductDetailTemplateKey(
            this.config.ProductDetailHtml,
            this.BaseApiUrl
          )
          return
        }
      }
      this.applyProductDetailHtmlToEditor(html)
      this.productDetailTemplateKey = key
      this.$message.success('已载入预设文案，可继续编辑后保存')
    }
  },

}
</script>

<style scoped>
/* ========== 设计令牌：青绿教育主题 ========== */
.badge-order-admin {
  --bo-primary: #0f766e;
  --bo-primary-mid: #14b8a6;
  --bo-primary-soft: #ccfbf1;
  --bo-primary-muted: #e6f6f3;
  --bo-accent: #c2410c;
  --bo-accent-soft: #ffedd5;
  --bo-surface: #ffffff;
  --bo-bg: #f3f7f6;
  --bo-border: #d5e3df;
  --bo-border-light: #e8f0ee;
  --bo-text: #134e4a;
  --bo-text-body: #334155;
  --bo-text-muted: #5f7a76;
  --bo-radius: 14px;
  --bo-radius-sm: 10px;
  --bo-shadow: 0 1px 3px rgba(15, 118, 110, 0.06);
  --bo-shadow-md: 0 8px 24px rgba(15, 118, 110, 0.08);
  padding: 20px 24px 28px;
  background: var(--bo-bg);
  height: 100%;
  max-height: 100%;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  color: var(--bo-text-body);
}

/* ========== 页头 ========== */
.bo-masthead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  flex-wrap: wrap;
}
.bo-masthead__brand {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}
.bo-masthead__mark {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: linear-gradient(145deg, var(--bo-primary) 0%, var(--bo-primary-mid) 100%);
  color: #fff;
  font-size: 22px;
  box-shadow: 0 6px 16px rgba(15, 118, 110, 0.28);
}
.bo-masthead__title {
  margin: 0 0 4px;
  font-size: 21px;
  font-weight: 700;
  color: var(--bo-text);
  letter-spacing: 0.02em;
}
.bo-masthead__desc {
  margin: 0;
  font-size: 13px;
  color: var(--bo-text-muted);
  line-height: 1.5;
}
.bo-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  border: 2px solid transparent;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.bo-status-pill.is-on {
  background: var(--bo-primary-soft);
  color: #047857;
  border-color: #99f6e4;
}
.bo-status-pill.is-off {
  background: #f1f5f9;
  color: #64748b;
  border-color: #e2e8f0;
}

/* ========== 概览快捷卡片 ========== */
.bo-overview {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}
@media (max-width: 1100px) {
  .bo-overview { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 520px) {
  .bo-overview { grid-template-columns: 1fr; }
}
.bo-overview-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: var(--bo-surface);
  border: 2px solid var(--bo-border-light);
  border-radius: var(--bo-radius);
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  box-shadow: var(--bo-shadow);
}
.bo-overview-card:hover {
  border-color: #a7d8d0;
  box-shadow: var(--bo-shadow-md);
  transform: translateY(-1px);
}
.bo-overview-card.is-active {
  border-color: var(--bo-primary-mid);
  background: linear-gradient(180deg, #ffffff 0%, var(--bo-primary-muted) 100%);
}
.bo-overview-card__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 18px;
}
.bo-overview-card__icon.tone-primary { background: var(--bo-primary-soft); color: var(--bo-primary); }
.bo-overview-card__icon.tone-accent { background: var(--bo-accent-soft); color: var(--bo-accent); }
.bo-overview-card__icon.tone-success { background: #dcfce7; color: #15803d; }
.bo-overview-card__icon.tone-muted { background: #f1f5f9; color: #64748b; }
.bo-overview-card__body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.bo-overview-card__value {
  font-size: 18px;
  font-weight: 700;
  color: var(--bo-text);
  line-height: 1.2;
}
.bo-overview-card__label {
  font-size: 12px;
  color: var(--bo-text-muted);
  margin-top: 2px;
}

/* ========== 侧栏 + 主内容 ========== */
.bo-workspace {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}
@media (max-width: 900px) {
  .bo-workspace { flex-direction: column; }
}
.bo-sidebar {
  flex-shrink: 0;
  width: 220px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
  background: var(--bo-surface);
  border: 1px solid var(--bo-border-light);
  border-radius: var(--bo-radius);
  box-shadow: var(--bo-shadow);
  position: sticky;
  top: 12px;
}
@media (max-width: 900px) {
  .bo-sidebar {
    width: 100%;
    position: static;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 8px;
  }
}
.bo-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: var(--bo-radius-sm);
  background: transparent;
  cursor: pointer;
  text-align: left;
  transition: background 0.18s ease, color 0.18s ease;
}
@media (max-width: 900px) {
  .bo-nav-item {
    width: auto;
    flex: 1 1 calc(50% - 8px);
    min-width: 140px;
  }
}
.bo-nav-item:hover {
  background: var(--bo-primary-muted);
}
.bo-nav-item.is-active {
  background: var(--bo-primary-soft);
  box-shadow: inset 3px 0 0 var(--bo-primary);
}
.bo-nav-item__icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f8fafc;
  color: var(--bo-primary);
  font-size: 16px;
}
.bo-nav-item.is-active .bo-nav-item__icon {
  background: #fff;
}
.bo-nav-item__text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.bo-nav-item__label {
  font-size: 14px;
  font-weight: 600;
  color: var(--bo-text-body);
  line-height: 1.3;
}
.bo-nav-item__hint {
  font-size: 11px;
  color: var(--bo-text-muted);
  margin-top: 1px;
}
.bo-nav-item__badge {
  flex-shrink: 0;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--bo-primary);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
}
.bo-main {
  flex: 1;
  min-width: 0;
}
.bo-pane {
  animation: bo-fade-in 0.22s ease;
}
@keyframes bo-fade-in {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}
@media (prefers-reduced-motion: reduce) {
  .bo-pane { animation: none; }
}

/* ========== 面板与提示 ========== */
/* 订购记录工具栏：轻量描边，避免全站实心 warning/danger 过重 */
.badge-order-admin .toolbar-filter-bar .toolbar-filter-actions .bo-toolbar-btn {
  color: var(--bo-primary) !important;
  background: #fff !important;
  border-color: var(--bo-border) !important;
  font-weight: 500;
  border-radius: 8px;
}

.badge-order-admin .toolbar-filter-bar .toolbar-filter-actions .bo-toolbar-btn:hover,
.badge-order-admin .toolbar-filter-bar .toolbar-filter-actions .bo-toolbar-btn:focus {
  color: var(--bo-primary) !important;
  background: var(--bo-primary-muted) !important;
  border-color: var(--bo-primary-mid) !important;
}

.badge-order-admin .toolbar-filter-bar .toolbar-filter-actions .bo-toolbar-btn--warn {
  color: #b45309 !important;
  background: #fff !important;
  border-color: #fde68a !important;
}

.badge-order-admin .toolbar-filter-bar .toolbar-filter-actions .bo-toolbar-btn--warn:hover,
.badge-order-admin .toolbar-filter-bar .toolbar-filter-actions .bo-toolbar-btn--warn:focus {
  color: #92400e !important;
  background: #fffbeb !important;
  border-color: #fcd34d !important;
}

.badge-order-admin .toolbar-filter-bar .toolbar-filter-actions .bo-toolbar-btn--danger {
  color: #b91c1c !important;
  background: #fff !important;
  border-color: #fecaca !important;
}

.badge-order-admin .toolbar-filter-bar .toolbar-filter-actions .bo-toolbar-btn--danger:hover,
.badge-order-admin .toolbar-filter-bar .toolbar-filter-actions .bo-toolbar-btn--danger:focus {
  color: #991b1b !important;
  background: #fef2f2 !important;
  border-color: #fca5a5 !important;
}

.badge-order-admin .toolbar-filter-bar .toolbar-filter-actions .bo-toolbar-btn.is-disabled,
.badge-order-admin .toolbar-filter-bar .toolbar-filter-actions .bo-toolbar-btn.is-disabled:hover {
  color: #94a3b8 !important;
  background: #f8fafc !important;
  border-color: #e2e8f0 !important;
}

.bo-panel {
  background: var(--bo-surface);
  border: 1px solid var(--bo-border-light);
  border-radius: var(--bo-radius);
  box-shadow: var(--bo-shadow);
  margin-bottom: 18px;
  overflow: hidden;
}
.bo-panel--muted {
  background: #fafcfb;
}
.bo-panel--filter {
  margin-bottom: 14px;
}
.bo-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 18px;
  border-bottom: 1px solid var(--bo-border-light);
  background: linear-gradient(180deg, #fafcfb 0%, #fff 100%);
}
.bo-panel__title {
  font-size: 15px;
  font-weight: 700;
  color: var(--bo-text);
  display: flex;
  align-items: center;
  gap: 8px;
}
.bo-panel__count {
  font-size: 12px;
  font-weight: 500;
  color: var(--bo-text-muted);
  padding: 2px 8px;
  background: var(--bo-primary-muted);
  border-radius: 999px;
}
.bo-panel__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.bo-panel__body {
  padding: 16px 18px;
}
.bo-panel__body--flush {
  padding: 0;
}
.bo-panel__body--flush >>> .el-table {
  border: none;
  border-radius: 0;
}
.bo-callout {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  margin-bottom: 16px;
  border-radius: var(--bo-radius-sm);
  background: var(--bo-primary-muted);
  border: 1px solid #b8e0d8;
  color: var(--bo-text);
  font-size: 13px;
  line-height: 1.55;
}
.bo-callout i {
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--bo-primary);
  font-size: 16px;
}
.bo-callout--warn {
  background: #fffbeb;
  border-color: #fde68a;
  color: #92400e;
}
.bo-callout--warn i {
  color: #d97706;
}

/* ========== 配置折叠面板 ========== */
.bo-collapse {
  border: none;
  margin-bottom: 8px;
}
.bo-collapse >>> .el-collapse-item {
  margin-bottom: 12px;
  border: 1px solid var(--bo-border-light);
  border-radius: var(--bo-radius);
  overflow: hidden;
  background: var(--bo-surface);
  box-shadow: var(--bo-shadow);
}
.bo-collapse >>> .el-collapse-item__header {
  height: auto;
  min-height: 48px;
  line-height: 1.4;
  padding: 12px 18px;
  font-weight: 600;
  color: var(--bo-text);
  background: linear-gradient(180deg, #fafcfb 0%, #fff 100%);
  border-bottom: 1px solid transparent;
}
.bo-collapse >>> .el-collapse-item.is-active .el-collapse-item__header {
  border-bottom-color: var(--bo-border-light);
}
.bo-collapse >>> .el-collapse-item__wrap {
  border: none;
}
.bo-collapse >>> .el-collapse-item__content {
  padding: 18px 20px 8px;
}
.bo-collapse__title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.bo-collapse__title i {
  color: var(--bo-primary);
  font-size: 16px;
}

/* ========== 基础设置表单 ========== */
.config-form {
  max-width: 1080px;
}
.config-form >>> .el-form-item {
  margin-bottom: 18px;
}
.config-form >>> .el-form-item__label {
  font-weight: 500;
  color: var(--bo-text-muted);
}
.config-form >>> .el-input__inner,
.config-form >>> .el-textarea__inner {
  border-radius: 8px;
  border-color: var(--bo-border);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.config-form >>> .el-input__inner:focus,
.config-form >>> .el-textarea__inner:focus {
  border-color: var(--bo-primary-mid);
  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.15);
}
.config-form >>> .el-switch.is-checked .el-switch__core {
  border-color: var(--bo-primary-mid);
  background-color: var(--bo-primary-mid);
}
.hint {
  display: inline-block;
  margin-left: 10px;
  color: var(--bo-text-muted);
  font-size: 12px;
}
.hint.warn {
  color: var(--bo-accent);
  font-weight: 500;
}
.form-tip {
  margin: 6px 0 0;
  font-size: 12px;
  color: var(--bo-text-muted);
  line-height: 1.5;
}
.form-tip.info {
  color: var(--bo-primary);
}
.form-tip i { margin-right: 4px; }
.form-tip--below-control {
  min-height: auto;
  padding-top: 4px;
}
.config-form-actions {
  text-align: center;
  padding: 12px 0 4px;
}
.save-btn {
  padding: 11px 32px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  background: var(--bo-primary) !important;
  border-color: var(--bo-primary) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.save-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(15, 118, 110, 0.3);
}

/* ========== 图片上传 ========== */
.config-image-upload {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.config-image-uploader >>> .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 120px;
  border-radius: 10px;
  border: 2px dashed var(--bo-border);
  background: var(--bo-primary-muted);
  transition: border-color 0.2s ease, background 0.2s ease;
}
.config-image-uploader >>> .el-upload--picture-card:hover {
  border-color: var(--bo-primary-mid);
  background: var(--bo-primary-soft);
  color: var(--bo-primary);
}
.upload-tip {
  margin: 8px 0 0;
  font-size: 12px;
  color: var(--bo-text-muted);
}
.config-image-preview { position: relative; }
.image-wrapper {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--bo-border);
}
.config-image-thumb {
  width: 120px;
  height: 120px;
  object-fit: cover;
  display: block;
}
.config-image-thumb--wide { width: 200px; height: 100px; }
.config-image-thumb--banner { width: 240px; height: 80px; }
.image-hover-mask {
  position: absolute;
  inset: 0;
  background: rgba(19, 78, 74, 0.72);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  opacity: 0;
  transition: opacity 0.22s ease;
  pointer-events: none;
}
.image-wrapper:hover .image-hover-mask {
  opacity: 1;
  pointer-events: auto;
}
.image-hover-mask span {
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}
.image-hover-mask span.danger { color: #fca5a5; }

/* ========== 收集字段卡片网格 ========== */
.field-card-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}
@media (max-width: 1280px) {
  .field-card-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}
@media (max-width: 900px) {
  .field-card-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 520px) {
  .field-card-grid { grid-template-columns: 1fr; }
}
.field-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 12px 10px 10px;
  border: 1px solid var(--bo-border-light);
  border-radius: 12px;
  background: #fff;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}
.field-card.is-enabled {
  border-color: #b8e0d8;
  background: linear-gradient(180deg, #fff 0%, #f4fbf9 100%);
}
.field-card.is-disabled {
  border-color: #fde68a;
  background: #fffdf8;
}
.field-card.is-empty {
  border-style: dashed;
  background: #fafcfb;
}
.field-card:hover {
  box-shadow: var(--bo-shadow-md);
  transform: translateY(-1px);
}
.field-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
}
.field-card__sort {
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 6px;
  background: var(--bo-primary-soft);
  color: var(--bo-primary);
  font-size: 11px;
  font-weight: 700;
}
.field-card.is-empty .field-card__sort,
.field-card.is-disabled .field-card__sort {
  background: #f1f5f9;
  color: #94a3b8;
}
.field-card__icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: var(--bo-primary-muted);
  color: var(--bo-primary);
  font-size: 17px;
  margin-bottom: 8px;
}
.field-card.is-empty .field-card__icon {
  background: #f1f5f9;
  color: #94a3b8;
}
.field-card__title {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 700;
  color: var(--bo-text);
  line-height: 1.3;
  width: 100%;
}
.field-card__tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
  margin-bottom: 6px;
  width: 100%;
}
.field-card__tags span {
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 10px;
  color: var(--bo-text-muted);
  background: #f1f5f9;
}
.field-card.is-enabled .field-card__tags span {
  background: var(--bo-primary-muted);
}
.field-card__desc {
  margin: 0 0 8px;
  width: 100%;
  min-height: 32px;
  font-size: 11px;
  line-height: 1.45;
  color: #94a3b8;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.field-card__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2px;
  width: 100%;
  padding-top: 8px;
  margin-top: auto;
  border-top: 1px solid var(--bo-border-light);
}
.field-card__actions >>> .el-button--text {
  padding: 2px 5px;
  font-size: 12px;
}
.field-status-dot {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  flex-shrink: 0;
}
.field-status-dot.is-on {
  background: #dcfce7;
  color: #15803d;
}
.field-status-dot.is-off {
  background: #f1f5f9;
  color: #94a3b8;
}
.field-status-dot.is-disabled {
  background: #ffedd5;
  color: #c2410c;
}
.text-muted {
  color: #94a3b8;
}

/* ========== 表格 ========== */
.badge-order-admin >>> .el-table {
  border-radius: 0;
  overflow: hidden;
}
.badge-order-admin >>> th {
  background: #f6faf9 !important;
  color: var(--bo-text-muted) !important;
  font-weight: 600 !important;
  border-bottom: 1px solid var(--bo-border-light) !important;
}
.badge-order-admin >>> td {
  border-bottom: 1px solid var(--bo-border-light) !important;
}
.thumb {
  max-width: 60px;
  max-height: 44px;
  object-fit: contain;
  border-radius: 6px;
  border: 1px solid var(--bo-border);
}
.thumb--clickable {
  cursor: pointer;
  transition: box-shadow 0.2s ease;
}
.thumb--clickable:hover {
  box-shadow: 0 0 0 2px var(--bo-primary-mid);
}
.template-default-tag {
  margin-left: 6px;
  vertical-align: middle;
}
.package-sort-no {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  border-radius: 6px;
  background: var(--bo-primary-soft);
  color: var(--bo-primary);
  font-size: 12px;
  font-weight: 700;
}

/* ========== 按钮与状态色 ========== */
.badge-order-admin >>> .el-button--primary {
  background-color: var(--bo-primary);
  border-color: var(--bo-primary);
}
.badge-order-admin >>> .el-button--primary:hover,
.badge-order-admin >>> .el-button--primary:focus {
  background-color: #0d6b63;
  border-color: #0d6b63;
}
.badge-order-admin >>> .el-button--primary.is-plain {
  color: var(--bo-primary);
  background-color: #f0faf9;
  border-color: #9fd9d4;
}
.badge-order-admin >>> .el-button--primary.is-plain:hover,
.badge-order-admin >>> .el-button--primary.is-plain:focus {
  color: #fff;
  background-color: var(--bo-primary);
  border-color: var(--bo-primary);
}
.badge-order-admin >>> .el-button--text {
  font-weight: 500;
  transition: color 0.15s ease;
}
.danger { color: #dc2626; }
.badge-order-admin >>> .el-button--text.danger:hover { color: #b91c1c; }
.warning { color: #d97706; }
.badge-order-admin >>> .el-button--text.warning:hover { color: #b45309; }

/* ========== 订单详情弹窗 ========== */
.bo-order-detail-dialog .el-dialog__body {
  padding-top: 8px;
  padding-bottom: 8px;
}
.order-detail {
  min-height: 320px;
}
.order-detail-tabs >>> .el-tabs__header {
  margin-bottom: 14px;
}
.order-detail-tabs >>> .el-tabs__item {
  height: 40px;
  line-height: 40px;
}
.order-detail-tab-badge {
  margin-left: 4px;
  vertical-align: middle;
}
.order-detail-tab-badge >>> .el-badge__content {
  position: static;
  transform: none;
  height: 16px;
  line-height: 16px;
  padding: 0 5px;
  border: none;
}
.order-detail-grid {
  display: grid;
  gap: 14px;
}
.order-detail-grid--2 {
  grid-template-columns: 1fr 1fr;
}
@media (max-width: 768px) {
  .order-detail-grid--2 {
    grid-template-columns: 1fr;
  }
}
.order-detail-card {
  padding: 16px;
  border: 1px solid var(--bo-border-light);
  border-radius: var(--bo-radius-sm);
  background: #fafcfb;
}
.order-detail-card__title {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 700;
  color: var(--bo-primary);
  letter-spacing: 0.04em;
}
.order-detail-dl {
  margin: 0;
}
.order-detail-dl > div {
  display: flex;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid var(--bo-border-light);
  font-size: 13px;
  line-height: 1.5;
}
.order-detail-dl > div:last-child { border-bottom: none; }
.order-detail-dl dt {
  flex-shrink: 0;
  width: 88px;
  margin: 0;
  color: var(--bo-text-muted);
  font-weight: 500;
}
.order-detail-dl dd {
  margin: 0;
  flex: 1;
  color: var(--bo-text-body);
  word-break: break-all;
}
.order-detail-dl dd .el-button--text {
  padding: 0;
  font-size: 13px;
}
.order-detail-pane {
  min-height: 220px;
}
.order-detail-photo {
  margin-top: 14px;
}
.order-detail-photo--inline {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--bo-border-light);
}
.order-detail-photo__img {
  display: block;
  width: 100px;
  height: 140px;
  margin-top: 8px;
  border-radius: var(--bo-radius-sm);
  border: 1px solid var(--bo-border);
  cursor: pointer;
}
.order-detail-photo__img >>> .el-image__inner,
.order-detail-photo__img >>> .el-image__preview {
  border-radius: var(--bo-radius-sm);
}
.order-detail-photo__hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: var(--bo-text-muted, #909399);
}
.order-detail-actions {
  margin-top: 16px;
}
.order-detail-actions--top {
  margin: 0 0 12px;
}
.order-refund-records { margin-top: 20px; }
.order-refund-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--bo-text);
  margin-bottom: 10px;
}

/* ========== 富文本编辑器 ========== */
.product-detail-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 14px;
  margin: 0 0 12px;
  padding: 12px 14px;
  background: var(--bo-primary-muted);
  border: 1px solid var(--bo-border-light);
  border-radius: var(--bo-radius-sm);
}
.product-detail-toolbar-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--bo-text);
}
.product-detail-toolbar .hint {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 0;
}
.product-detail-editor >>> .ql-container,
.product-detail-editor >>> .ql-editor {
  min-height: 300px;
  border-bottom-left-radius: var(--bo-radius-sm);
  border-bottom-right-radius: var(--bo-radius-sm);
}
.product-detail-editor >>> .ql-toolbar {
  border-top-left-radius: var(--bo-radius-sm);
  border-top-right-radius: var(--bo-radius-sm);
  background: #f6faf9;
  border-color: var(--bo-border);
}
.product-detail-editor >>> .ql-container {
  border-color: var(--bo-border);
}

/* ========== 样式模板弹窗 ========== */
.style-preview-card {
  margin-bottom: 16px;
  border-radius: var(--bo-radius);
  border: 1px solid var(--bo-border-light);
}
.template-bg-fixed-preview {
  width: 360px;
  max-width: 100%;
  padding: 8px;
  border: 1px solid var(--bo-border-light);
  border-radius: var(--bo-radius-sm);
  background: #fff;
}
.template-bg-fixed-preview img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 6px;
}
.preview-block-title {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 700;
  color: var(--bo-text);
}

/* ========== 模拟器弹窗 ========== */
.mock-control-panel {
  padding: 16px 18px;
  background: var(--bo-primary-muted);
  border-radius: var(--bo-radius-sm);
  border: 1px solid var(--bo-border-light);
}
.mock-control-title {
  margin: 0 0 14px;
  font-size: 14px;
  font-weight: 700;
  color: var(--bo-text);
  padding-bottom: 10px;
  border-bottom: 1px solid var(--bo-border-light);
  display: flex;
  align-items: center;
  gap: 6px;
}
.mock-control-title i { color: var(--bo-primary); }
.mock-control-form >>> .el-form-item {
  margin-bottom: 12px;
}
.mock-control-form >>> .el-form-item__label {
  font-weight: 600;
  color: var(--bo-text-muted);
  padding-bottom: 4px;
  line-height: 1.2;
}
.mock-avatar-uploader-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.mock-canvas-wrapper {
  padding: 18px;
  background: #fff;
  border-radius: var(--bo-radius);
  border: 1px solid var(--bo-border-light);
  box-shadow: var(--bo-shadow-md);
}
.mock-control-tip {
  margin-top: 12px;
  font-size: 12px;
  color: var(--bo-text-muted);
  line-height: 1.55;
  border-top: 1px dashed var(--bo-border);
  padding-top: 10px;
}

/* ========== 杂项 ========== */
.ali-pay-option-appid {
  margin-left: 8px;
  font-size: 11px;
  color: var(--bo-text-muted);
  background: var(--bo-primary-muted);
  padding: 2px 6px;
  border-radius: 4px;
}
.config-required-star {
  color: #dc2626;
  margin-right: 2px;
}
.image-preview-full {
  width: 100%;
  border-radius: var(--bo-radius-sm);
  display: block;
}
.badge-order-admin >>> .el-pagination {
  margin-top: 0 !important;
  padding: 12px 16px !important;
  display: flex !important;
  justify-content: flex-end !important;
  background: #fafcfb !important;
  border-top: 1px solid var(--bo-border-light) !important;
}
.badge-order-admin >>> .el-button--text,
.badge-order-admin >>> .el-button--text:hover,
.badge-order-admin >>> .el-button--text:focus,
.badge-order-admin >>> .el-button--text:active {
  text-decoration: none !important;
  outline: none !important;
}
</style>

